/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import { injectable } from 'inversify'
import { ICoverageDiscoveryResponseApiClient } from './contracts'
import { ICoverageDiscoveryResponses, IBaseResponse, IBaseResponseDetail, IInpatientTypeInsurance } from '../CoverageDiscoveryResponseStateManager/contracts'

@injectable()
export class MockCoverageDiscoveryResponseApiClient implements ICoverageDiscoveryResponseApiClient {
	public allResponses: ICoverageDiscoveryResponses[] = []
	public effectiveDate: any = new Date('07,07,1998')
	public cInsurance: IInpatientTypeInsurance[] = [
		{
			planName: 'RAC=1204/BSP=CNP',
			insuranceTypeDescription: 'Health Maintenance Organization (HMO)',
			coverageLevel: 'IND',
			coverageLevelDescription: 'Individual',
			benefits: [
				{
					authRequired: null,
					benefitInfoCode: 'MC',
					benefitInfoCodeDefinition: 'Managed Care Coordinator',
					benefitTimePeriodCode: null,
					benefitTimePeriodCodeDefinition: null,
					coverageLevelCode: 'IND',
					coverageLevelCodeDefinition: 'Individual',
					inNetwork: null,
					insuranceDescription: null,
					insuranceTypeCode: 'HM',
					insuranceTypeCodeDefinition: 'Health Maintenance Organization (HMO)',
					monetaryAmount: 0,
					monetaryAmountString: null,
					percent: 0,
					percentString: null,
					procedureCode: null,
					procedureCodeEnd: null,
					procedureModifier1: null,
					procedureModifier2: null,
					procedureModifier3: null,
					procedureModifier4: null,
					quantity: 0,
					quantityString: null,
					quantityQualifierCode: null,
					quantityQualifierCodeDefinition: '',
					serviceTypeCode: null,
					serviceTypeCodeDefinition: null,
					additionalIdentifications: [],
					benefitAdditionalInfos: [],

					deliveryPatterns: [],
					relatedEntities: [
						{
							typeCode: 'Y2',
							typeCodeDefinition: 'Managed Care Organization',
							qualifierCode: null,
							qualifierCodeDefinition: null,
							lastOrOrgName: 'Spokane RSN - Mental Health Services Only',
							firstName: '',
							middleName: '',
							nameSuffix: '',
							identifier: null,
							identifierCode: null,
							identifierCodeDefinition: null,
							address1: null,
							address2: null,
							city: null,
							state: null,
							zip: null,

							providerCodeDefinition: null,
							providerIdentifier: '105021301',
							providerIdentifierCode: 'PI',
							providerIdentifierCodeDefinition: 'Payer Identification',
							relatedEntityContacts: [
								{
									name: 'SPOKANE RSN - MENTAL HEALTH SERVICES ONLY',
									number1: '(800) 273-5864',
									number1Code: 'TE',
									number1CodeDefinition: 'Telephone',
									number2: null,
									number2Code: null,
									number2CodeDefinition: null,
									number3: null,
									number3Code: null,
									number3CodeDefinition: null,
								},
							],
						},
					],
					textMessages: [],
				},
			],
		},
	]
	public identifiers: any = [
		{
			item1: 'Sub. Identity Card Number:',
			item2: '000000000',
		},
		{
			item1: 'Sub. Plan Number:',
			item2: '181-HCA EAST',
		},
	]
	public planName: any = '"HC-ENHANCED COVERAGE"'
	public planNetwork: any = ['Test1', 'Test2']
	public commercialInsuranceDetails: any = [
		{
			code: '1',
			description: 'Active Coverage',
			lines: [
				{
					sections: [
						{
							isBold: false,
							value: '\u003Cspan class=\u0027sectionHeader\u0027\u003EPlan\u003C/span\u003E:',
						},
						{
							isBold: false,
							value: '7/1/1998',
						},
					],
				},
				{
					sections: [
						{
							isBold: false,
							value: '\u003Cspan class=\u0027sectionHeader\u0027\u003EMessage\u003C/span\u003E: 0 - Beneficiary insured due to age OASI',
						},
					],
				},
			],
		},
		{
			code: '1',
			description: 'Active Coverage',
			lines: [
				{
					sections: [
						{
							isBold: false,
							value: '\u003Cspan class=\u0027sectionHeader\u0027\u003EPlan\u003C/span\u003E:',
						},
						{
							isBold: false,
							value: '7/1/1998',
						},
					],
				},
				{
					sections: [
						{
							isBold: false,
							value: '\u003Cspan class=\u0027sectionHeader\u0027\u003EMessage\u003C/span\u003E: 0 - Beneficiary insured due to age OASI',
						},
					],
				},
			],
		},
	]
	public baseResponseDetail: IBaseResponseDetail[] = [
		{
			id: 1,
			payer: {
				id: 1,
				code: '10000',
				name: 'Medicare (HETS)',
				payerTypeId: 1,
			},
		},
		{
			id: 2,
			payer: {
				id: 2,
				code: '10001',
				name: 'Commercial',
				payerTypeId: 6,
			},
		},
		{
			id: 3,
			payer: {
				id: 3,
				code: '10002',
				name: 'MediAid',
				payerTypeId: 2,
			},
		},
	]

	constructor() {
		this.allResponses.push({
			responseId: 1,
			payerList: ['abc', 'bcd', 'res'],
			response: [
				{
					sections: [
						{
							id: 'sectionPatient',
							loadOrder: 1,
							displayOrder: 1,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
						{
							id: 'sectionServiceCoverage',
							loadOrder: 1,
							displayOrder: 2,
							isFiltered: true,
							summary: {
								serviceTypes: [
									{
										code: '30',
										definition: 'Health Benefit Plan Coverage',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												code: 'PS',
												definition: 'Point of Service (POS)',
												insuranceDescription: 'Medical Plan',
												additionalPayers: [],
												effectiveDateRanges: [
													{
														item1: new Date('0001-01-01T00:00:00'),
														item2: new Date('0001-01-01T00:00:00'),
													},
												],
												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
											{
												code: '',
												definition: null,
												insuranceDescription: '',
												additionalPayers: [],

												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [
														{
															startDate: new Date('2016-01-01T00:00:00'),
															endDate: new Date('0001-01-01T00:00:00'),
															total: 500.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
													],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
										],
										exclusions: [],
										createdDate: new Date('2021-02-25T18:18:43.6406131+05:30'),
									},
									{
										code: '32',
										definition: 'Plan Waiting Period',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												code: '',
												definition: null,
												insuranceDescription: '',
												additionalPayers: [],

												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
										],
										exclusions: [],
										createdDate: new Date('2021-02-25T18:18:43.6406131+05:30'),
									},
									{
										code: '88',
										definition: 'Pharmacy',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												code: 'OT',
												definition: 'Other',
												insuranceDescription: null,
												additionalPayers: [
													{
														additionalIdentifiers: [
															{
																identifier: 'S1234 567',
																identifierCode: 'MI',
																identifierCodeDefinition: 'Mill Order Number',
																description: null,
															},
														],
														startDate: new Date('2013-09-01T00:00:00'),
														endDate: new Date('0001-01-01T00:00:00'),
														message: 'MA BILL OPTION CODE',
														insuranceTypeCodeDefinition: 'Other',
														name: 'WELLCARE PRESCRIPTION INSURANCE, INC.',
														address1: '8735 Henderson Rd, Renaissance 2',
														address2: null,
														city: 'Tampa',
														state: 'FL',
														zip: '33634',
														telephone: '(888) 888-9355',
													},
												],

												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
										],
										exclusions: [],
										createdDate: new Date('2021-02-25T18:18:43.6406131+05:30'),
									},
								],
								procedureCodes: [],
								isHCPCS: false,
								index: 3,
								preferenceKey: 'eligSum3',
								title: 'Service Coverage Overview',
								sections: [
									{
										key: '30',
										value: 'Health Benefit Plan Coverage (30)',
									},
									{
										key: '88',
										value: 'Pharmacy (88)',
									},
									{
										key: '32',
										value: 'Plan Waiting Period (32)',
									},
								],
								selectedSections: ['30', '88', '32'],
							},
						},

						{
							eligibilitySummary: {
								planDescription: '',
								planNetwork: [],
								planDate: '7/1/1998',
								dateOfDeath: new Date('0001-01-01T00:00:00'),
								partAActives: [
									{
										item1: new Date('1998-07-01T00:00:00'),
										item2: new Date('0001-01-01T00:00:00'),
									},
								],
								partBActives: [
									{
										Item1: new Date('2003-12-01T00:00:00'),
										Item2: new Date('0001-01-01T00:00:00'),
									},
								],
								inactivePeriods: [],
								eligibilitySummaryStatus: {
									classColor: 'eligibility-summary status-active',
									largeImage: 'Active_Coverage_White-Border.png',
									status: 'Active Coverage',
									description: 'Active Coverage',
								},
								managedCareCoordinatorName: 'managedCareCoordinator1',
								partAEntitlementReason: '0 – Beneficiary insured due to age OASI',
								partBEntitlementReason: '1 – Beneficiary insured due to age OASI',
							},
							id: 'sectionEligibility',
							loadOrder: 3,
							displayOrder: 3,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},

						{
							statusAlerts: {
								insurances: [
									{
										type: 3,
										typeString: 'Medicare Part D',
										code: 'OT',
										definition: 'Other',
										insuranceDescription: '',
										additionalPayers: [
											{
												additionalIdentifiers: [
													{
														identifier: 'S1234 567',
														identifierCode: '18',
														identifierCodeDefinition: 'Plan Number',
														description: null,
													},
												],
												startDate: new Date('2013-09-01T00:00:00'),
												endDate: new Date('0001-01-01T00:00:00'),
												message: 'MA BILL OPTION CODE - C',
												insuranceTypeCodeDefinition: 'Preferred Provider Organization (PPO)',
												name: 'WELLCARE PRESCRIPTION INSURANCE, INC.',
												address1: '8735 Henderson Rd, Renaissance 2',
												address2: null,
												city: 'Tampa',
												state: 'FL',
												zip: '33634',
												telephone: '(888) 888-9355',
											},
										],
										effectiveDateRanges: [],
										coInsurances: [],
										coPayments: {
											episodeDefinition: 'Spell',
											frequencyDefinition: null,
											periodDefinition: null,
											schedules: [],
											episodes: [],
										},
										deductibles: {
											episodeDefinition: 'Spell',
											episodes: [],
											schedules: [],
										},
										reserve: {
											quantityQualifier: null,
											lifetime: 0.0,
											remaining: 0.0,
											coPays: [],
										},
										descriptions: [],
										limitations: [],
										endOfPeriod2: null,
									},
									{
										type: 1,
										typeString: 'Medicare Advantage',
										code: 'PS',
										definition: 'Point of Service (POS)',
										insuranceDescription: 'Medical Plan',
										additionalPayers: [],
										effectiveDateRanges: [
											{
												item1: new Date('0001-01-01T00:00:00'),
												item2: new Date('0001-01-01T00:00:00'),
											},
										],
										coInsurances: [],
										coPayments: {
											episodeDefinition: 'Spell',
											frequencyDefinition: null,
											periodDefinition: null,
											schedules: [],
											episodes: [],
										},
										deductibles: {
											episodeDefinition: 'Spell',
											episodes: [],
											schedules: [],
										},
										reserve: {
											quantityQualifier: null,
											lifetime: 0.0,
											remaining: 0.0,
											coPays: [],
										},
										descriptions: [],
										limitations: [],
										endOfPeriod2: null,
									},
								],
								matchedOtherPayers: null,
							},
							id: 'sectionStatusAlerts',
							loadOrder: 4,
							displayOrder: 5,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},

						{
							id: 'sectionInpatient',
							loadOrder: 5,
							displayOrder: 6,
							isFiltered: true,
							summary: {
								inpatientCoPayments: [
									{
										episodeDefinition: 'Spell',
										frequencyDefinition: null,
										periodDefinition: null,
										schedules: [],
										episodes: [],
									},
									{
										episodeDefinition: 'Spell',
										frequencyDefinition: null,
										periodDefinition: 'Day',
										schedules: [
											{
												startDate: new Date('2018-01-01T00:00:00'),
												endDate: new Date('2018-12-31T00:00:00'),
												fromPeriod: 1,
												toPeriod: 60,
												amount: 0.0,
												remaining: 60.0,
												periodCode: '26',
												doeba: new Date('2018-01-01T00:00:00'),
												dolba: new Date('2018-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
											{
												startDate: new Date('2018-01-01T00:00:00'),
												endDate: new Date('2018-12-31T00:00:00'),
												fromPeriod: 61,
												toPeriod: 90,
												amount: 0.0,
												remaining: 30.0,
												periodCode: '7',
												doeba: new Date('2018-01-01T00:00:00'),
												dolba: new Date('2018-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
											{
												startDate: new Date('2017-01-01T00:00:00'),
												endDate: new Date('2017-12-31T00:00:00'),
												fromPeriod: 1,
												toPeriod: 60,
												amount: 0.0,
												remaining: 60.0,
												periodCode: '26',
												doeba: new Date('2017-01-01T00:00:00'),
												dolba: new Date('2017-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
											{
												startDate: new Date('2017-01-01T00:00:00'),
												endDate: new Date('2017-12-31T00:00:00'),
												fromPeriod: 61,
												toPeriod: 90,
												amount: 0.0,
												remaining: 30.0,
												periodCode: '7',
												doeba: new Date('2017-01-01T00:00:00'),
												dolba: new Date('2017-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
											{
												startDate: new Date('2016-01-01T00:00:00'),
												endDate: new Date('2016-12-31T00:00:00'),
												fromPeriod: 1,
												toPeriod: 60,
												amount: 0.0,
												remaining: 60.0,
												periodCode: '26',
												doeba: new Date('2016-01-01T00:00:00'),
												dolba: new Date('2016-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
											{
												startDate: new Date('2016-01-01T00:00:00'),
												endDate: new Date('2016-12-31T00:00:00'),
												fromPeriod: 61,
												toPeriod: 90,
												amount: 0.0,
												remaining: 30.0,
												periodCode: '7',
												doeba: new Date('2016-01-01T00:00:00'),
												dolba: new Date('2016-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
										],
										episodes: [],
									},
									{
										episodeDefinition: 'Spell',
										frequencyDefinition: null,
										periodDefinition: null,
										schedules: [],
										episodes: [],
									},
									{
										episodeDefinition: 'Spell',
										frequencyDefinition: null,
										periodDefinition: null,
										schedules: [],
										episodes: [],
									},
								],
								inpatientTypes: [
									{
										code: '30',
										definition: 'Health Benefit Plan Coverage',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												code: 'MA',
												definition: 'Medicare Part A',
												insuranceDescription: null,
												additionalPayers: [],
												effectiveDateRanges: [
													{
														item1: new Date('1997-07-01T00:00:00'),
														item2: new Date('0001-01-01T00:00:00'),
													},
												],
												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: 'Days',
													lifetime: 60.0,
													remaining: 60.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
											{
												code: 'QM',
												definition: 'Medicare Part A (QMB)',
												insuranceDescription: 'Medicare Part A',
												additionalPayers: [],

												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: 'Day',
													schedules: [
														{
															startDate: new Date('2018-01-01T00:00:00'),
															endDate: new Date('2018-12-31T00:00:00'),
															fromPeriod: 1,
															toPeriod: 60,
															amount: 0.0,
															remaining: 60.0,
															periodCode: '26',
															doeba: new Date('2018 - 01 - 01T00: 00: 00'),
															dolba: new Date('2018-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
														{
															startDate: new Date('2018-01-01T00:00:00'),
															endDate: new Date('2018-12-31T00:00:00'),
															fromPeriod: 61,
															toPeriod: 90,
															amount: 0.0,
															remaining: 30.0,
															periodCode: '7',
															doeba: new Date('2018 - 01 - 01T00: 00: 00'),
															dolba: new Date('2018-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
														{
															startDate: new Date('2017-01-01T00:00:00'),
															endDate: new Date('2017-12-31T00:00:00'),
															fromPeriod: 1,
															toPeriod: 60,
															amount: 0.0,
															remaining: 60.0,
															periodCode: '26',
															doeba: new Date('2017 - 01 - 01T00: 00: 00'),
															dolba: new Date('2017-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
														{
															startDate: new Date('2017-01-01T00:00:00'),
															endDate: new Date('2017-12-31T00:00:00'),
															fromPeriod: 61,
															toPeriod: 90,
															amount: 0.0,
															remaining: 30.0,
															periodCode: '7',
															doeba: new Date('2017 - 01 - 01T00: 00: 00'),
															dolba: new Date('2017-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
														{
															startDate: new Date('2016-01-01T00:00:00'),
															endDate: new Date('2016-12-31T00:00:00'),
															fromPeriod: 1,
															toPeriod: 60,
															amount: 0.0,
															remaining: 60.0,
															periodCode: '26',
															doeba: new Date('2016 - 01 - 01T00: 00: 00'),
															dolba: new Date('2016-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
														{
															startDate: new Date('2016-01-01T00:00:00'),
															endDate: new Date('2016-12-31T00:00:00'),
															fromPeriod: 61,
															toPeriod: 90,
															amount: 0.0,
															remaining: 30.0,
															periodCode: '7',
															doeba: new Date('2016 - 01 - 01T00: 00: 00'),
															dolba: new Date('2016-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
													],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [
														{
															startDate: new Date('2018-01-01T00:00:00'),
															endDate: new Date('2018-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
														{
															startDate: new Date('2017-01-01T00:00:00'),
															endDate: new Date('2017-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
														{
															startDate: new Date('2016-01-01T00:00:00'),
															endDate: new Date('2016-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
													],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
											{
												code: 'MB',
												definition: 'Medicare Part B',
												insuranceDescription: null,
												additionalPayers: [],
												effectiveDateRanges: [
													{
														item1: new Date('1996-02-01T00:00:00'),
														item2: new Date('0001-01-01T00:00:00'),
													},
												],
												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
											{
												code: 'QM',
												definition: 'Medicare Part B (QMB)',
												insuranceDescription: 'Medicare Part B',
												additionalPayers: [],

												coInsurances: [
													{
														startDate: new Date('2018-01-01T00:00:00'),
														endDate: new Date('2018-12-31T00:00:00'),
														percent: 0.0,
														message: '',
													},
													{
														startDate: new Date('2017-01-01T00:00:00'),
														endDate: new Date('2017-12-31T00:00:00'),
														percent: 0.0,
														message: '',
													},
													{
														startDate: new Date('2016-01-01T00:00:00'),
														endDate: new Date('2016-12-31T00:00:00'),
														percent: 0.0,
														message: '',
													},
												],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [
														{
															startDate: new Date('2018-01-01T00:00:00'),
															endDate: new Date('2018-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
														{
															startDate: new Date('2017-01-01T00:00:00'),
															endDate: new Date('2017-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
														{
															startDate: new Date('2016-01-01T00:00:00'),
															endDate: new Date('2016-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
													],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
											{
												code: 'HN',
												definition: 'Health Maintenance Organization (HMO) - Medicare Risk',
												insuranceDescription: 'This is test plan',
												additionalPayers: [
													{
														additionalIdentifiers: [
															{
																identifier: 'H8677 001',
																identifierCode: '18',
																identifierCodeDefinition: 'Plan Number',
																description: null,
															},
														],
														startDate: new Date('2015-01-01T00:00:00'),
														endDate: new Date('0001-01-01T00:00:00'),
														message: 'MA Bill Option Code - A',
														insuranceTypeCodeDefinition: 'Health Maintenance Organization (HMO) - Medicare Risk',
														name: 'MOLINA HEALTHCARE OF CALIFORNIA',
														address1: '200 Oceangate',
														address2: 'Ste. 100',
														city: 'Long Beach',
														state: 'CA',
														zip: '90802',
														telephone: '(888) 562-5442',
													},
												],

												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
										],
										exclusions: [],
										createdDate: new Date('2021-02-17T13:38:03.3739642'),
									},
									{
										code: '48',
										definition: 'Hospital - Inpatient',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												code: 'MA',
												definition: 'Medicare Part A',
												insuranceDescription: null,
												additionalPayers: [],
												effectiveDateRanges: [
													{
														item1: new Date('1997-07-01T00:00:00'),
														item2: new Date('0001-01-01T00:00:00'),
													},
												],
												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
										],
										exclusions: [],
										createdDate: new Date('2021-02-17T13:38:03.3739642'),
									},
								],
								snfCoPayments: [
									{
										episodeDefinition: 'Spell',
										frequencyDefinition: null,
										periodDefinition: null,
										schedules: [],
										episodes: [],
									},
									{
										episodeDefinition: 'Spell',
										frequencyDefinition: null,
										periodDefinition: 'Day',
										schedules: [
											{
												startDate: new Date('2018-01-01T00:00:00'),
												endDate: new Date('2018-12-31T00:00:00'),
												fromPeriod: 1,
												toPeriod: 20,
												amount: 0.0,
												remaining: 20.0,
												periodCode: '26',
												doeba: new Date('2018 - 01 - 01T00: 00: 00'),
												dolba: new Date('2018-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
											{
												startDate: new Date('2018-01-01T00:00:00'),
												endDate: new Date('2018-12-31T00:00:00'),
												fromPeriod: 21,
												toPeriod: 100,
												amount: 0.0,
												remaining: 80.0,
												periodCode: '7',
												doeba: new Date('2018 - 01 - 01T00: 00: 00'),
												dolba: new Date('2018-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
											{
												startDate: new Date('2017-01-01T00:00:00'),
												endDate: new Date('2017-12-31T00:00:00'),
												fromPeriod: 1,
												toPeriod: 20,
												amount: 0.0,
												remaining: 20.0,

												periodCode: '26',
												doeba: new Date('2017 - 01 - 01T00: 00: 00'),
												dolba: new Date('2017-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
											{
												startDate: new Date('2017-01-01T00:00:00'),
												endDate: new Date('2017-12-31T00:00:00'),
												fromPeriod: 21,
												toPeriod: 100,
												amount: 0.0,
												remaining: 80.0,

												periodCode: '7',
												doeba: new Date('2017 - 01 - 01T00: 00: 00'),
												dolba: new Date('2017-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
											{
												startDate: new Date('2016-01-01T00:00:00'),
												endDate: new Date('2016-12-31T00:00:00'),
												fromPeriod: 1,
												toPeriod: 20,
												amount: 0.0,
												remaining: 20.0,

												periodCode: '26',
												doeba: new Date('2016 - 01 - 01T00: 00: 00'),
												dolba: new Date('2016-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
											{
												startDate: new Date('2016-01-01T00:00:00'),
												endDate: new Date('2016-12-31T00:00:00'),
												fromPeriod: 21,
												toPeriod: 100,
												amount: 0.0,
												remaining: 80.0,

												periodCode: '7',
												doeba: new Date('2016 - 01 - 01T00: 00: 00'),
												dolba: new Date('2016-12-31T00:00:00'),
												isDolbaDoebaPresent: true,
											},
										],
										episodes: [],
									},
								],
								snfTypes: [
									{
										code: 'AG',
										definition: 'Skilled Nursing Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												code: 'MA',
												definition: 'Medicare Part A',
												insuranceDescription: null,
												additionalPayers: [],
												effectiveDateRanges: [
													{
														item1: new Date('1997-07-01T00:00:00'),
														item2: new Date('0001-01-01T00:00:00'),
													},
												],
												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
											{
												code: 'QM',
												definition: 'Medicare Part A (QMB)',
												insuranceDescription: 'Medicare Part A',
												additionalPayers: [],

												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: 'Day',
													schedules: [
														{
															startDate: new Date('2018-01-01T00:00:00'),
															endDate: new Date('2018-12-31T00:00:00'),
															fromPeriod: 1,
															toPeriod: 20,
															amount: 0.0,
															remaining: 20.0,
															periodCode: '26',
															doeba: new Date('2018 - 01 - 01T00: 00: 00'),
															dolba: new Date('2018-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
														{
															startDate: new Date('2018-01-01T00:00:00'),
															endDate: new Date('2018-12-31T00:00:00'),
															fromPeriod: 21,
															toPeriod: 100,
															amount: 0.0,
															remaining: 80.0,
															periodCode: '7',
															doeba: new Date('2018 - 01 - 01T00: 00: 00'),
															dolba: new Date('2018-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
														{
															startDate: new Date('2017-01-01T00:00:00'),
															endDate: new Date('2017-12-31T00:00:00'),
															fromPeriod: 1,
															toPeriod: 20,
															amount: 0.0,
															remaining: 20.0,
															periodCode: '26',
															doeba: new Date('2017 - 01 - 01T00: 00: 00'),
															dolba: new Date('2017-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
														{
															startDate: new Date('2017-01-01T00:00:00'),
															endDate: new Date('2017-12-31T00:00:00'),
															fromPeriod: 21,
															toPeriod: 100,
															amount: 0.0,
															remaining: 80.0,
															periodCode: '7',
															doeba: new Date('2017-01 -01T00:00:00'),
															dolba: new Date('2017-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
														{
															startDate: new Date('2016-01-01T00:00:00'),
															endDate: new Date('2016-12-31T00:00:00'),
															fromPeriod: 1,
															toPeriod: 20,
															amount: 0.0,
															remaining: 20.0,
															periodCode: '26',
															doeba: new Date('2016-01-01T00: 00: 00'),
															dolba: new Date('2016-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
														{
															startDate: new Date('2016-01-01T00:00:00'),
															endDate: new Date('2016-12-31T00:00:00'),
															fromPeriod: 21,
															toPeriod: 100,
															amount: 0.0,
															remaining: 80.0,
															periodCode: '7',
															doeba: new Date('2016-01 -01T00: 00: 00'),
															dolba: new Date('2016-12-31T00:00:00'),
															isDolbaDoebaPresent: true,
														},
													],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
										],
										exclusions: [],
										createdDate: new Date('2021-02-17T13:38:03.3739642'),
									},
								],
								esrdEffectiveDate: new Date('2021-02-17T13:38:03.3739642'),
								esrdEndDate: new Date('0001-01-01T00:00:00'),
								esrdDialysisEffectiveDate: new Date('0001-01-01T00:00:00'),
								esrdDialysisEndDate: new Date('0001-01-01T00:00:00'),
								esrdTransplantEffectiveDate: new Date('0001-01-01T00:00:00'),
								esrdTransplantEndDate: new Date('0001-01-01T00:00:00'),
								index: 0,
								preferenceKey: 'eligSum0',
								title: 'Inpatient/SNF/ESRD',
								sections: [
									{
										key: '0',
										value: 'Inpatient Days Remaining',
									},
									{
										key: '1',
										value: 'SNF Days Remaining',
									},
									{
										key: '2',
										value: 'End Stage Renal Disease',
									},
								],
								selectedSections: ['0', '1', '2'],
							},
						},

						{
							id: 'sectionHomeHospice',
							loadOrder: 5,
							displayOrder: 7,
							isFiltered: true,
							summary: {
								homeCertificationDates: [],
								homeRecertificationDates: [],
								homeHealthTypes: [
									{
										code: '42',
										definition: 'Home Health Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												code: 'MA',
												definition: 'Medicare Part A',
												insuranceDescription: '',
												additionalPayers: [],
												effectiveDateRanges: [
													{
														item1: new Date('1998-07-01T00:00:00'),
														item2: new Date('0001-01-01T00:00:00'),
													},
												],
												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [
														{
															startDate: new Date('2014-01-01T00:00:00'),
															endDate: new Date('2014-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
														{
															startDate: new Date('2013-01-01T00:00:00'),
															endDate: new Date('2013-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
													],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
											{
												code: 'MB',
												definition: 'Medicare Part B',
												insuranceDescription: '',
												additionalPayers: [],
												effectiveDateRanges: [
													{
														item1: new Date('2003-12-01T00:00:00'),
														item2: new Date('0001-01-01T00:00:00'),
													},
												],
												coInsurances: [
													{
														startDate: new Date('2014-01-01T00:00:00'),
														endDate: new Date('2014-12-31T00:00:00'),
														percent: 0.0,
														message: '',
													},
													{
														startDate: new Date('2013-01-01T00:00:00'),
														endDate: new Date('2013-12-31T00:00:00'),
														percent: 0.0,
														message: '',
													},
												],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [
														{
															startDate: new Date('2014-01-01T00:00:00'),
															endDate: new Date('2014-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
														{
															startDate: new Date('2013-01-01T00:00:00'),
															endDate: new Date('2013-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
													],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
										],
										facilities: [],
										exclusions: [],
										createdDate: new Date('2021-02-16T13:46:44.5258974'),
									},
								],
								hospiceTypes: [
									{
										code: '45',
										definition: 'Hospice',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												code: 'MA',
												definition: 'Medicare Part A',
												insuranceDescription: '',
												additionalPayers: [],
												effectiveDateRanges: [
													{
														item1: new Date('1998-07-01T00:00:00'),
														item2: new Date('0001-01-01T00:00:00'),
													},
												],
												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [
														{
															startDate: new Date('2014-01-01T00:00:00'),
															endDate: new Date('2014-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
														{
															startDate: new Date('2013-01-01T00:00:00'),
															endDate: new Date('2013-12-31T00:00:00'),
															total: 0.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
													],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [
													{
														startDate: new Date('0001-01-01T00:00:00'),
														endDate: new Date('0001-01-01T00:00:00'),
														esrdStartDate: new Date('0001-01-01T00:00:00'),
														esrdEndDate: new Date('0001-01-01T00:00:00'),
														esrdDialysisStartDate: new Date('0001-01-01T00:00:00'),
														esrdDialysisEndDate: new Date('0001-01-01T00:00:00'),
														esrdTransplantStartDate: new Date('0001-01-01T00:00:00'),
														esrdTransplantEndDate: new Date('0001-01-01T00:00:00'),
														message: null,
														amount: 0.0,
														isHospice: true,
														occurences: 0,
													},
												],
												limitations: [],
												endOfPeriod2: null,
											},
										],
										facilities: [],
										exclusions: [],
										createdDate: new Date('2021-02-16T13:46:44.5258974'),
									},
								],
								index: 1,
								preferenceKey: 'eligSum1',
								title: 'Home Health & Hospice',
								sections: [
									{
										key: '0',
										value: 'Home Health Certification',
									},
									{
										key: '1',
										value: 'Home Health Care',
									},
									{
										key: '2',
										value: 'Hospice',
									},
								],
								selectedSections: ['0', '1', '2'],
							},
						},

						{
							id: 'sectionTherapyCap',
							loadOrder: 5,
							displayOrder: 8,
							isFiltered: true,
							summary: {
								deductibleType: {
									code: '30',
									definition: 'Health Benefit Plan Coverage',
									isActive: true,
									status: 'Active Coverage',
									insurances: [
										{
											code: 'MA',
											definition: 'Medicare Part A',
											insuranceDescription: '',
											additionalPayers: [],
											effectiveDateRanges: [
												{
													item1: new Date('1997-07-01T00:00:00'),
													item2: new Date('0001 - 01 - 01T00: 00: 00'),
												},
											],
											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: 'Days',
												lifetime: 60.0,
												remaining: 60.0,
												coPays: [],
											},
											descriptions: [],
											limitations: [],
											endOfPeriod2: null,
										},
										{
											code: 'QM',
											definition: 'Medicare Part A (QMB)',
											insuranceDescription: 'Medicare Part A',
											additionalPayers: [],

											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: 'Day',
												schedules: [
													{
														startDate: new Date('2018-01-01T00:00:00'),
														endDate: new Date('2018-12-31T00:00:00'),
														fromPeriod: 1,
														toPeriod: 60,
														amount: 0.0,
														remaining: 60.0,

														periodCode: '26',
														doeba: new Date('2018-01-01T00:00:00'),
														dolba: new Date('2018-12-31T00:00:00'),
														isDolbaDoebaPresent: true,
													},
													{
														startDate: new Date('2018-01-01T00:00:00'),
														endDate: new Date('2018-12-31T00:00:00'),
														fromPeriod: 61,
														toPeriod: 90,
														amount: 0.0,
														remaining: 30.0,
														periodCode: '7',
														doeba: new Date('2018-01-01T00:00:00'),
														dolba: new Date('2018-12-31T00:00:00'),
														isDolbaDoebaPresent: true,
													},
													{
														startDate: new Date('2017-01-01T00:00:00'),
														endDate: new Date('2017-12-31T00:00:00'),
														fromPeriod: 1,
														toPeriod: 60,
														amount: 0.0,
														remaining: 60.0,
														periodCode: '26',
														doeba: new Date('2017-01-01T00:00:00'),
														dolba: new Date('2017-12-31T00:00:00'),
														isDolbaDoebaPresent: true,
													},
													{
														startDate: new Date('2017-01-01T00:00:00'),
														endDate: new Date('2017-12-31T00:00:00'),
														fromPeriod: 61,
														toPeriod: 90,
														amount: 0.0,
														remaining: 30.0,
														periodCode: '7',
														doeba: new Date('2017-01-01T00:00:00'),
														dolba: new Date('2017-12-31T00:00:00'),
														isDolbaDoebaPresent: true,
													},
													{
														startDate: new Date('2016-01-01T00:00:00'),
														endDate: new Date('2016-12-31T00:00:00'),
														fromPeriod: 1,
														toPeriod: 60,
														amount: 0.0,
														remaining: 60.0,
														periodCode: '26',
														doeba: new Date('2016-01-01T00:00:00'),
														dolba: new Date('2016-12-31T00:00:00'),
														isDolbaDoebaPresent: true,
													},
													{
														startDate: new Date('2016-01-01T00:00:00'),
														endDate: new Date('2016-12-31T00:00:00'),
														fromPeriod: 61,
														toPeriod: 90,
														amount: 0.0,
														remaining: 30.0,
														periodCode: '7',
														doeba: new Date('2016-01-01T00:00:00'),
														dolba: new Date('2016-12-31T00:00:00'),
														isDolbaDoebaPresent: true,
													},
												],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [
													{
														startDate: new Date('2018-01-01T00:00:00'),
														endDate: new Date('2018-12-31T00:00:00'),
														total: 0.0,
														remaining: 0.0,
														hasRemaining: false,
														monetaryAmount: 0.0,
													},
													{
														startDate: new Date('2017-01-01T00:00:00'),
														endDate: new Date('2017-12-31T00:00:00'),
														total: 0.0,
														remaining: 0.0,
														hasRemaining: false,
														monetaryAmount: 0.0,
													},
													{
														startDate: new Date('2016-01-01T00:00:00'),
														endDate: new Date('2016-12-31T00:00:00'),
														total: 0.0,
														remaining: 0.0,
														hasRemaining: false,
														monetaryAmount: 0.0,
													},
												],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [],
											limitations: [],
											endOfPeriod2: null,
										},
										{
											code: 'MB',
											definition: 'Medicare Part B',
											insuranceDescription: 'Medicare Part B Desc',
											additionalPayers: [],
											effectiveDateRanges: [
												{
													item1: new Date('1996-02-01T00:00:00'),
													item2: new Date('0001-01-01T00:00:00'),
												},
											],
											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [],
											limitations: [],
											endOfPeriod2: null,
										},
										{
											code: 'QM',
											definition: 'Medicare Part B (QMB)',
											insuranceDescription: 'Medicare Part B',
											additionalPayers: [],

											coInsurances: [
												{
													startDate: new Date('2018-01-01T00:00:00'),
													endDate: new Date('2018-12-31T00:00:00'),
													percent: 0.0,
													message: '',
												},
												{
													startDate: new Date('2017-01-01T00:00:00'),
													endDate: new Date('2017-12-31T00:00:00'),
													percent: 0.0,
													message: '',
												},
												{
													startDate: new Date('2016-01-01T00:00:00'),
													endDate: new Date('2016-12-31T00:00:00'),
													percent: 0.0,
													message: '',
												},
											],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [
													{
														startDate: new Date('2018-01-01T00:00:00'),
														endDate: new Date('2018-12-31T00:00:00'),
														total: 0.0,
														remaining: 0.0,
														hasRemaining: false,
														monetaryAmount: 0.0,
													},
													{
														startDate: new Date('2017-01-01T00:00:00'),
														endDate: new Date('2017-12-31T00:00:00'),
														total: 0.0,
														remaining: 0.0,
														hasRemaining: false,
														monetaryAmount: 0.0,
													},
													{
														startDate: new Date('2016-01-01T00:00:00'),
														endDate: new Date('2016-12-31T00:00:00'),
														total: 0.0,
														remaining: 0.0,
														hasRemaining: false,
														monetaryAmount: 0.0,
													},
												],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [],
											limitations: [],
											endOfPeriod2: null,
										},
										{
											code: 'HN',
											definition: 'Health Maintenance Organization (HMO) - Medicare Risk',
											insuranceDescription: 'This is test plan',
											additionalPayers: [
												{
													additionalIdentifiers: [
														{
															identifier: 'H8677 001',
															identifierCode: '18',
															identifierCodeDefinition: 'Plan Number',
															description: null,
														},
													],
													startDate: new Date('2015-01-01T00:00:00'),
													endDate: new Date('0001-01-01T00:00:00'),
													message: 'MA Bill Option Code - A',
													insuranceTypeCodeDefinition: 'Health Maintenance Organization (HMO) - Medicare Risk',
													name: 'MOLINA HEALTHCARE OF CALIFORNIA',
													address1: '200 Oceangate',
													address2: 'Ste. 100',
													city: 'Long Beach',
													state: 'CA',
													zip: '90802',
													telephone: '(888) 562-5442',
												},
											],

											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [],
											limitations: [],
											endOfPeriod2: null,
										},
									],
									facilities: [],
									exclusions: [],
									createdDate: new Date('2021-02-17T13:38:03.3739642'),
								},
								cardiacType: {
									code: 'BG',
									definition: 'Cardiac Rehabilitation',
									isActive: true,
									status: 'Active Coverage',
									insurances: [
										{
											code: 'MB',
											definition: 'Medicare Part B',
											insuranceDescription: 'Medicare Part B MB Description',
											additionalPayers: [],
											effectiveDateRanges: [
												{
													item1: new Date('1996-02-01T00:00:00'),
													item2: new Date('0001-01-01T00:00:00'),
												},
											],
											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [],
											limitations: [
												{
													quantityQualifier: '99',
													quantityDescription: 'Used',
													remaining: 0.0,
													total: 0.0,
													used: 0.0,
													message: 'Technical',
													eligibleDate: new Date('0001-01-01T00:00:00'),
													effectiveDate: new Date('0001-01-01T00:00:00'),
												},
												{
													quantityQualifier: '99',
													quantityDescription: 'Used',
													remaining: 0.0,
													total: 0.0,
													used: 0.0,
													message: 'Professional',
													eligibleDate: new Date('0001-01-01T00:00:00'),
													effectiveDate: new Date('0001-01-01T00:00:00'),
												},
												{
													quantityQualifier: '99',
													quantityDescription: 'Used',
													remaining: 0.0,
													total: 0.0,
													used: 0.0,
													message: 'Intensive Cardiac Rehabilitation - Technical',
													eligibleDate: new Date('0001-01-01T00:00:00'),
													effectiveDate: new Date('0001-01-01T00:00:00'),
												},
												{
													quantityQualifier: '99',
													quantityDescription: 'Used',
													remaining: 0.0,
													total: 0.0,
													used: 0.0,
													message: 'Intensive Cardiac Rehabilitation - Professional',
													eligibleDate: new Date('0001-01-01T00:00:00'),
													effectiveDate: new Date('0001-01-01T00:00:00'),
												},
											],
											endOfPeriod2: null,
										},
									],
									facilities: [],
									exclusions: [],
									createdDate: new Date('2021-02-17T13:38:03.3739642'),
								},
								occupationalType: {
									code: 'AD',
									definition: 'Occupational Therapy',
									isActive: true,
									status: 'Active Coverage',
									insurances: [
										{
											code: 'MB',
											definition: 'Medicare Part B',
											insuranceDescription: '',
											additionalPayers: [],
											effectiveDateRanges: [
												{
													item1: new Date('1996-02-01T00:00:00'),
													item2: new Date('0001-01-01T00:00:00'),
												},
											],
											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [
												{
													startDate: new Date('2017-01-01T00:00:00'),
													endDate: new Date('2017-12-31T00:00:00'),
													esrdStartDate: new Date('0001-01-01T00:00:00'),
													esrdEndDate: new Date('0001-01-01T00:00:00'),
													esrdDialysisStartDate: new Date('0001-01-01T00:00:00'),
													esrdDialysisEndDate: new Date('0001-01-01T00:00:00'),
													esrdTransplantStartDate: new Date('0001-01-01T00:00:00'),
													esrdTransplantEndDate: new Date('0001-01-01T00:00:00'),
													message: 'Used Amount',
													amount: 0.0,
													isHospice: false,
													occurences: 0,
												},
												{
													startDate: new Date('2016-01-01T00:00:00'),
													endDate: new Date('2016-12-31T00:00:00'),
													esrdStartDate: new Date('0001-01-01T00:00:00'),
													esrdEndDate: new Date('0001-01-01T00:00:00'),
													esrdDialysisStartDate: new Date('0001-01-01T00:00:00'),
													esrdDialysisEndDate: new Date('0001-01-01T00:00:00'),
													esrdTransplantStartDate: new Date('0001-01-01T00:00:00'),
													esrdTransplantEndDate: new Date('0001-01-01T00:00:00'),
													message: 'Used Amount',
													amount: 0.0,
													isHospice: false,
													occurences: 0,
												},
											],
											limitations: [],
											endOfPeriod2: null,
										},
									],
									facilities: [],
									exclusions: [],
									createdDate: new Date('2021-02-17T13:38:03.3739642'),
								},
								physicalType: {
									code: 'AE',
									definition: 'Physical Medicine',
									isActive: true,
									status: 'Active Coverage',
									insurances: [
										{
											code: 'MB',
											definition: 'Medicare Part B',
											insuranceDescription: '',
											additionalPayers: [],
											effectiveDateRanges: [
												{
													item1: new Date('1996-02-01T00:00:00'),
													item2: new Date('0001-01-01T00:00:00'),
												},
											],
											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [
												{
													startDate: new Date('2017-01-01T00:00:00'),
													endDate: new Date('2017-12-31T00:00:00'),
													esrdStartDate: new Date('0001-01-01T00:00:00'),
													esrdEndDate: new Date('0001-01-01T00:00:00'),
													esrdDialysisStartDate: new Date('0001-01-01T00:00:00'),
													esrdDialysisEndDate: new Date('0001-01-01T00:00:00'),
													esrdTransplantStartDate: new Date('0001-01-01T00:00:00'),
													esrdTransplantEndDate: new Date('0001-01-01T00:00:00'),
													message: 'Used Amount',
													amount: 0.0,
													isHospice: false,
													occurences: 0,
												},
												{
													startDate: new Date('2016-01-01T00:00:00'),
													endDate: new Date('2016-12-31T00:00:00'),
													esrdStartDate: new Date('0001-01-01T00:00:00'),
													esrdEndDate: new Date('0001-01-01T00:00:00'),
													esrdDialysisStartDate: new Date('0001-01-01T00:00:00'),
													esrdDialysisEndDate: new Date('0001-01-01T00:00:00'),
													esrdTransplantStartDate: new Date('0001-01-01T00:00:00'),
													esrdTransplantEndDate: new Date('0001-01-01T00:00:00'),
													message: 'Used Amount',
													amount: 0.0,
													isHospice: false,
													occurences: 0,
												},
											],
											limitations: [],
											endOfPeriod2: null,
										},
									],
									facilities: [],
									exclusions: [],
									createdDate: new Date('2021-02-17T13:38:03.3739642'),
								},
								pulmonaryType: {
									code: 'BF',
									definition: 'Pulmonary Rehabilitation',
									isActive: true,
									status: 'Active Coverage',
									insurances: [
										{
											code: 'MB',
											definition: 'Medicare Part B',
											insuranceDescription: '',
											additionalPayers: [],
											effectiveDateRanges: [
												{
													item1: new Date('1996-02-01T00:00:00'),
													item2: new Date('0001-01-01T00:00:00'),
												},
											],
											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [],
											limitations: [
												{
													quantityQualifier: 'CA',
													quantityDescription: 'Remaining',
													remaining: 72.0,
													total: 0.0,
													used: 0.0,
													message: 'Technical',
													eligibleDate: new Date('0001-01-01T00:00:00'),
													effectiveDate: new Date('0001-01-01T00:00:00'),
												},
												{
													quantityQualifier: 'CA',
													quantityDescription: 'Remaining',
													remaining: 72.0,
													total: 0.0,
													used: 0.0,
													message: 'Professional',
													eligibleDate: new Date('0001-01-01T00:00:00'),
													effectiveDate: new Date('0001-01-01T00:00:00'),
												},
											],
											endOfPeriod2: null,
										},
									],
									facilities: [],
									exclusions: [],
									createdDate: new Date('2021-02-17T13:38:03.3739642'),
								},
								smokingType: {
									code: '67',
									definition: 'Smoking Cessation',
									isActive: true,
									status: 'Active Coverage',
									insurances: [
										{
											code: 'MB',
											definition: 'Medicare Part B',
											insuranceDescription: '',
											additionalPayers: [],
											effectiveDateRanges: [
												{
													item1: new Date('1996-02-01T00:00:00'),
													item2: new Date('0001-01-01T00:00:00'),
												},
											],
											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [],
											limitations: [
												{
													quantityQualifier: 'VS',
													quantityDescription: 'Remaining',
													remaining: 8.0,
													total: 8.0,
													used: 0.0,
													message: null,
													eligibleDate: new Date('0001-01-01T00:00:00'),
													effectiveDate: new Date('0001-01-01T00:00:00'),
												},
											],
											endOfPeriod2: null,
										},
									],
									facilities: [],
									exclusions: [],
									createdDate: new Date('2021-02-17T13:38:03.3739642'),
								},
								bloodType: {
									code: '10',
									definition: 'Blood Charges',
									isActive: true,
									status: 'Active Coverage',
									insurances: [
										{
											code: 'MA',
											definition: 'Medicare Part A',
											insuranceDescription: '',
											additionalPayers: [],
											effectiveDateRanges: [
												{
													item1: new Date('1997-07-01T00:00:00'),
													item2: new Date('0001-01-01T00:00:00'),
												},
											],
											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [],
											limitations: [],
											endOfPeriod2: null,
										},
										{
											code: 'MB',
											definition: 'Medicare Part B',
											insuranceDescription: '',
											additionalPayers: [],
											effectiveDateRanges: [
												{
													item1: new Date('1996-02-01T00:00:00'),
													item2: new Date('0001-01-01T00:00:00'),
												},
											],
											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [],
											limitations: [],
											endOfPeriod2: null,
										},
										{
											code: '',
											definition: '',
											insuranceDescription: '',
											additionalPayers: [],

											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0.0,
												remaining: 0.0,
												coPays: [],
											},
											descriptions: [],
											limitations: [],
											endOfPeriod2: null,
										},
									],
									facilities: [],
									exclusions: [
										{
											endDate: new Date('2017-12-31T00:00:00'),
											startDate: new Date('2017-01-01T00:00:00'),
											remaining: 3,
											quantityQualifier: null,
										},
										{
											endDate: new Date('2016-12-31T00:00:00'),
											startDate: new Date('2016-01-01T00:00:00'),
											remaining: 3,
											quantityQualifier: null,
										},
										{
											endDate: new Date('2018-12-31T00:00:00'),
											startDate: new Date('2018-01-01T00:00:00'),
											remaining: 3,
											quantityQualifier: null,
										},
									],
									createdDate: new Date('2021-02-17T13:38:03.3739642'),
								},
								acupuncture: {
									code: '64',
									definition: 'Acupuncture',
									isActive: true,
									status: 'Active Coverage',
									insurances: [
										{
											code: 'MB',
											definition: 'Medicare Part B',
											insuranceDescription: '',
											additionalPayers: [],
											effectiveDateRanges: [],
											coInsurances: [],
											coPayments: {
												episodeDefinition: 'Spell',
												frequencyDefinition: null,
												periodDefinition: null,
												schedules: [],
												episodes: [],
											},
											deductibles: {
												episodeDefinition: 'Spell',
												episodes: [],
												schedules: [],
											},
											reserve: {
												quantityQualifier: null,
												lifetime: 0,
												remaining: 0,
												coPays: [],
											},
											descriptions: [],
											limitations: [
												{
													quantityQualifier: 'CA',
													quantityDescription: 'Remaining',
													remaining: 19,
													total: 0,
													used: 0,
													message: 'Technical',
													eligibleDate: new Date('0001-01-01T00:00:00'),
													effectiveDate: new Date('2021-01-07T00:00:00'),
													serviceTypeCode: '64',
												},
												{
													quantityQualifier: 'CA',
													quantityDescription: 'Remaining',
													remaining: 20,
													total: 0,
													used: 0,
													message: 'Professional',
													eligibleDate: new Date('2020-11-10T00:00:00'),
													effectiveDate: new Date('0001-01-01T00:00:00'),
													serviceTypeCode: '64',
												},
												{
													quantityQualifier: 'CA',
													quantityDescription: 'Remaining',
													remaining: 19,
													total: 0,
													used: 0,
													message: 'Technical',
													eligibleDate: new Date('0001-01-01T00:00:00'),
													effectiveDate: new Date('2011-01-07T00:00:00'),
													serviceTypeCode: '64',
												},
												{
													quantityQualifier: 'CA',
													quantityDescription: 'Remaining',
													remaining: 20,
													total: 0,
													used: 0,
													message: 'Professional',
													eligibleDate: new Date('2010-11-10T00:00:00'),
													effectiveDate: new Date('0001-01-01T00:00:00'),
													serviceTypeCode: '64',
												},
												{
													quantityQualifier: 'CA',
													quantityDescription: 'Remaining',
													remaining: 19,
													total: 0,
													used: 0,
													message: 'Technical',
													eligibleDate: new Date('0001-01-01T00:00:00'),
													effectiveDate: new Date('2001-01-07T00:00:00'),
													serviceTypeCode: '64',
												},
												{
													quantityQualifier: 'CA',
													quantityDescription: 'Remaining',
													remaining: 20,
													total: 0,
													used: 0,
													message: 'Professional',
													eligibleDate: new Date('2000-11-10T00:00:00'),
													effectiveDate: new Date('0001-01-01T00:00:00'),
													serviceTypeCode: '64',
												},
											],
											endOfPeriod2: null,
										},
									],
									facilities: [],
									exclusions: [],
									createdDate: new Date('2000-11-10T00:00:00'),
								},
								index: 2,
								preferenceKey: 'eligSum2',
								title: 'Therapy Caps',
								sections: [
									{
										key: '2',
										value: 'OT/PT/ST Caps',
									},
									{
										key: '3',
										value: 'Pulmonary Rehab Service Limits',
									},
									{
										key: '4',
										value: 'Cardiac Rehab',
									},
									{
										key: '5',
										value: 'Blood Deductible',
									},
									{
										key: '6',
										value: 'Smoking Cessation',
									},
									{
										key: '7',
										value: 'Acupuncture Benefit Limits',
									},
								],
								selectedSections: ['2', '3', '4', '5', '6', '7'],
							},
						},
						{
							id: 'sectionServiceType',
							loadOrder: 8,
							displayOrder: 9,
							isFiltered: true,
							summary: {
								serviceTypes: [
									{
										code: '30',
										definition: 'Health Benefit Plan Coverage',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												code: 'PS',
												definition: 'Point of Service (POS)',
												insuranceDescription: 'Medical Plan',
												additionalPayers: [],
												effectiveDateRanges: [
													{
														item1: new Date('0001-01-01T00:00:00'),
														item2: new Date('0001-01-01T00:00:00'),
													},
												],
												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
											{
												code: '',
												definition: null,
												insuranceDescription: '',
												additionalPayers: [],

												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [
														{
															startDate: new Date('2016-01-01T00:00:00'),
															endDate: new Date('0001-01-01T00:00:00'),
															total: 500.0,
															remaining: 0.0,
															hasRemaining: false,
															monetaryAmount: 0.0,
														},
													],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
										],
										exclusions: [],
										createdDate: new Date('2021-02-25T18:18:43.6406131+05:30'),
									},
									{
										code: '32',
										definition: 'Plan Waiting Period',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												code: '',
												definition: null,
												insuranceDescription: '',
												additionalPayers: [],

												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
										],
										exclusions: [],
										createdDate: new Date('2021-02-25T18:18:43.6406131+05:30'),
									},
									{
										code: '88',
										definition: 'Pharmacy',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												code: 'OT',
												definition: 'Other',
												insuranceDescription: null,
												additionalPayers: [
													{
														additionalIdentifiers: [
															{
																identifier: 'S1234 567',
																identifierCode: 'MI',
																identifierCodeDefinition: 'Mill Order Number',
																description: null,
															},
														],
														startDate: new Date('2013-09-01T00:00:00'),
														endDate: new Date('0001-01-01T00:00:00'),
														message: 'MCO BILL OPTION CODE',
														insuranceTypeCodeDefinition: 'Other',
														name: 'WELLCARE PRESCRIPTION INSURANCE, INC.',
														address1: '8735 Henderson Rd, Renaissance 2',
														address2: null,
														city: 'Tampa',
														state: 'FL',
														zip: '33634',
														telephone: '(888) 888-9355',
													},
												],

												coInsurances: [],
												coPayments: {
													episodeDefinition: 'Spell',
													frequencyDefinition: null,
													periodDefinition: null,
													schedules: [],
													episodes: [],
												},
												deductibles: {
													episodeDefinition: 'Spell',
													episodes: [],
													schedules: [],
												},
												reserve: {
													quantityQualifier: null,
													lifetime: 0.0,
													remaining: 0.0,
													coPays: [],
												},
												descriptions: [],
												limitations: [],
												endOfPeriod2: null,
											},
										],
										exclusions: [],
										createdDate: new Date('2021-02-25T18:18:43.6406131+05:30'),
									},
								],
								procedureCodes: [],
								isHCPCS: false,
								index: 3,
								preferenceKey: 'eligSum3',
								title: 'Service Types',
								sections: [
									{
										key: '30',
										value: 'Health Benefit Plan Coverage (30)',
									},
									{
										key: '88',
										value: 'Pharmacy (88)',
									},
									{
										key: '32',
										value: 'Plan Waiting Period (32)',
									},
								],
								selectedSections: ['30', '88', '32'],
							},
						},
						{
							displayOrder: 10,
							id: 'sectionPreventative',
							isFiltered: true,
							loadOrder: 9,
							summary: {
								index: 5,
								preferenceKey: 'eligSum5',
								sections: [
									{ key: '77057', value: 'Screening Mammography (MAMM) - 77057' },
									{ key: '80061', value: 'Cardiovascular Disease Screening (CARD) - 80061' },
									{ key: '82270', value: 'Fecal Occult Blood Test (FOBT) - 82270' },
								],
								selectedSections: ['77057', '80061', '82270'],
								procedureCodes: [
									{
										code: '90670',
										definition: 'Screening Mammography (MAMM)',
										eligibleProfessional: new Date(1167589800000),
										eligibleTechnical: new Date(1167589800000),
										homeCertificationDates: [],
										homeRecertificationDates: [],
										deductibleTotal: 30,
										deductibleRemaining: 20,
										coInsurance: 15,
										providerNPI: 'Dev123',
										pPVDos: [
											{ key: '1/1/2013', value: '123' },
											{ key: '1/1/2014', value: '456' },
											{ key: '1/1/2015', value: '173' },
											{ key: '1/1/2016', value: '189' },
										],
									},
									{ code: '90732', definition: 'Cardiovascular Disease Screening(CARD)', eligibleProfessional: new Date(1136053800000), eligibleTechnical: new Date(1136053800000), homeCertificationDates: [], homeRecertificationDates: [], deductibleTotal: 30, deductibleRemaining: 20, coInsurance: 15, providerNPI: 'Dev123-1', pPVDos: [{ key: '1/1/2013', value: '123' }] },
									{ code: '90999', definition: 'Cardiovascular Disease(CARD)', eligibleProfessional: new Date(1136053800000), eligibleTechnical: new Date(1136053800000), homeCertificationDates: [], homeRecertificationDates: [], deductibleTotal: 30, deductibleRemaining: 20, coInsurance: 20, providerNPI: 'Dev123-1', pPVDos: [{ key: '1/1/2013', value: '123' }] },

									{ code: '90670', definition: 'Fecal Occult Blood Test (FOBT)', eligibleProfessional: new Date(1167589800000), eligibleTechnical: new Date(1167589800000), homeCertificationDates: [], homeRecertificationDates: [], deductibleTotal: 0, deductibleRemaining: 0, coInsurance: 0, providerNPI: null, pPVDos: [] },
								],

								title: 'Preventative',
								isHCPCS: false,
							},
						},

						{
							displayOrder: 11,
							id: 'sectionStay',
							isFiltered: true,
							loadOrder: 11,
							summary: {
								hospitalSpells: [
									{ doeba: new Date('2000-02-02'), dolba: new Date('2000-04-02'), spellId: 1, stays: [], eligibilityBenifits: [] },
									{
										doeba: new Date('2000-02-02'),
										dolba: new Date('2000-04-02'),
										spellId: 2,
										stays: [{ npis: ['9177541472'], dateRanges: [{ startDate: new Date('2000-03-02'), endDate: new Date('2000-04-02'), endDateString: '2000-04-02', startDateString: '2000-04-02', qualifierCode: '', qualifierCodeDefinition: '' }], doeba: new Date(), dolba: new Date() }],
										eligibilityBenifits: [],
									},
									{
										doeba: new Date('2001-02-02'),
										dolba: new Date('2001-04-02'),
										spellId: 3,
										stays: [{ npis: ['1234567895', '1234567896'], dateRanges: [{ startDate: new Date('2001-03-02'), endDate: new Date('2001-04-02'), endDateString: '2001-04-02', startDateString: '2001-04-02', qualifierCode: '', qualifierCodeDefinition: '' }], doeba: new Date(), dolba: new Date() }],
										eligibilityBenifits: [],
									},
								],
								snfSpells: [
									{ doeba: new Date('2000-02-02'), dolba: new Date('2000-04-02'), spellId: 1, stays: [], eligibilityBenifits: [] },
									{
										doeba: new Date('2000-02-02'),
										dolba: new Date('2000-04-02'),
										spellId: 2,
										stays: [{ npis: ['1234567893', '1234567894'], dateRanges: [{ startDate: new Date('2000-03-02'), endDate: new Date('2000-04-02'), endDateString: '2000-04-02', startDateString: '2000-04-02', qualifierCode: '', qualifierCodeDefinition: '' }], doeba: new Date(), dolba: new Date() }],
										eligibilityBenifits: [],
									},
									{
										doeba: new Date('2001-02-02'),
										dolba: new Date('2001-04-02'),
										spellId: 3,
										stays: [{ npis: ['1234567895', '1234567896'], dateRanges: [{ startDate: new Date('2001-03-02'), endDate: new Date('2001-04-02'), qualifierCode: '', qualifierCodeDefinition: '' }], doeba: new Date(), dolba: new Date() }],
										eligibilityBenifits: [],
									},
								],

								index: 6,
								preferenceKey: 'eligSum6',
								sections: [
									{
										key: '0',
										value: 'Hospital Section',
									},
									{
										key: '1',
										value: 'SNF Section',
									},
								],
								selectedSections: ['0', '1'],

								title: 'Hospital/SNF Stays',
							},
						},
						{
							id: '1',
							loadOrder: 0,
							displayOrder: 0,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
						{
							id: 'sectionImmunization',
							loadOrder: 4,
							displayOrder: 4,
							isFiltered: true,
							summary: {
								immunizationEligibility: {
									medicarePartBEligible: true,
								},
								immunizationHistory: [
									{
										code: '91300',
										immunizationDate: new Date('2021-01-23T00:00:00'),
										renderingNpi: '1234567893',
									},
									{
										code: '0002A',
										immunizationDate: new Date('2021-01-23T00:00:00'),
										renderingNpi: '1234567896',
									},
									{
										code: '0001A',
										immunizationDate: new Date('2020-12-21T00:00:00'),
										renderingNpi: '1987654327',
									},
									{
										code: '0012A',
										immunizationDate: new Date('2021-02-06T00:00:00'),
										renderingNpi: '1234567894',
									},
									{
										code: '0011A',
										immunizationDate: new Date('2021-01-07T00:00:00'),
										renderingNpi: '1234567895',
									},
								],
								immunizationInsurance: {
									code: 'MB',
									definition: 'Medicare Part B',
									insuranceDescription: null,
									additionalPayers: [],
									effectiveDateRanges: [
										{
											item1: new Date('2005-04-01T00:00:00'),
											item2: new Date('0001-01-01T00:00:00'),
										},
										{
											item1: new Date('2021-02-14T00:00:00'),
											item2: new Date('0001-01-01T00:00:00'),
										},
									],
									coInsurances: [
										{
											startDate: new Date('2021-01-01T00:00:00'),
											endDate: new Date('2021-12-31T00:00:00'),
											percent: 0.0,
											message: '',
										},
									],
									coPayments: {
										episodeDefinition: 'Spell',
										frequencyDefinition: null,
										periodDefinition: null,
										schedules: [],
										episodes: [],
									},
									deductibles: {
										episodeDefinition: 'Spell',
										episodes: [],
										schedules: [
											{
												startDate: new Date('2021-01-01T00:00:00'),
												endDate: new Date('2021-12-31T00:00:00'),
												total: 0.0,
												remaining: 0.0,
												hasRemaining: false,
												monetaryAmount: 0.0,
											},
										],
									},
									reserve: {
										quantityQualifier: null,
										lifetime: 0.0,
										remaining: 0.0,
										coPays: [],
									},
									descriptions: [],
									limitations: [],
									endOfPeriod2: null,
								},
								index: 7,
								preferenceKey: 'eligSum7',
								title: 'COVID-19 Immunizations',
								sections: [
									{
										key: '0',
										value: 'Immunization Eligibility',
									},
									{
										key: '1',
										value: 'Immunization History',
									},
								],
								selectedSections: ['0', '1'],
							},
						},
					],
					eligibilityResponse: {
						responseDateTime: new Date('0001-01-01T00:00:00'),
						responseDateTimeString: '01-01-0001 12:00:00 AM',
						payer: {
							id: 1,
							code: '10000',
							name: 'Medicare (HETS)',
							payerTypeId: 1,
						},
						raw271: 'ISA*00*          *00*          *ZZ*IVANS-TU-RT    *ZZ*EO-IVANS-RT    *160303*1105*^*00501*505001330*0*P*:~GS*HB*IVANS-TU-RT*EO-IVANS-RT*20160303*1105*505001330*X*005010X279A1~ST*271*150594834*005010X279A1~BHT*0022*11*1196790*20160303*110556~HL*1**20*1~NM1*PR*2*Healthcare One*****PI*10011~HL*2*1*21*1~NM1*1P*2*CUSTOMER*****XX*1849997391~HL*3*2*22*0~TRN*2*976304*9870011234*PL2053~TRN*1*5677663571*9ABILITYNT~NM1*IL*1*SHOULDHAVECOVERAGE*JTEST****MI*908080808RW~DMG*D8*19520203~INS*Y*18*001*25~DTP*472*D8*20151201~EB*1*EMP*30*PS*Medical Plan~EB*C*IND*30***23*500*****Y~DTP*346*D8*20160101~MSG*Test Message~EB*C*IND*32***23*700*****Y~EB*R**88*OT~REF*MI*S1234 567~DTP*292*D8*20130901~LS*2120~NM1*PR*2*WELLCARE PRESCRIPTION INSURANCE, INC.~N3*8735 Henderson Rd, Renaissance 2~N4*Tampa*FL*33634~PER*IC**TE*8888889355*UR*www.wellcarepdp.com~SE*15*150223334~GE*1*505001330~IEA*1*505001330~',
						eligibilityBenefits: [
							{
								authRequired: null,
								benefitInfoCode: '1',
								benefitInfoCodeDefinition: 'Active Coverage',
								benefitTimePeriodCode: null,
								benefitTimePeriodCodeDefinition: null,
								coverageLevelCode: 'EMP',
								coverageLevelCodeDefinition: 'Employee Only',
								inNetwork: null,
								insuranceDescription: 'Medical Plan',
								insuranceTypeCode: 'PS',
								insuranceTypeCodeDefinition: 'Point of Service (POS)',
								monetaryAmount: 0.0,
								monetaryAmountString: null,
								percent: 0.0,
								percentString: null,
								procedureCode: null,
								procedureCodeEnd: null,
								procedureModifier1: null,
								procedureModifier2: null,
								procedureModifier3: null,
								procedureModifier4: null,
								quantity: 0.0,
								quantityString: null,
								quantityQualifierCode: null,
								quantityQualifierCodeDefinition: '',
								serviceTypeCode: '30',
								serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
								additionalIdentifications: [],
								benefitAdditionalInfos: [],

								deliveryPatterns: [],
								relatedEntities: [],
								textMessages: [],
							},
							{
								authRequired: '',
								benefitInfoCode: 'C',
								benefitInfoCodeDefinition: 'Deductible',
								benefitTimePeriodCode: '23',
								benefitTimePeriodCodeDefinition: 'Calendar Year',
								coverageLevelCode: 'IND',
								coverageLevelCodeDefinition: 'Individual',
								inNetwork: 'Y',
								insuranceDescription: '',
								insuranceTypeCode: '',
								insuranceTypeCodeDefinition: null,
								monetaryAmount: 500.0,
								monetaryAmountString: '500',
								percent: 0.0,
								percentString: '',
								procedureCode: null,
								procedureCodeEnd: null,
								procedureModifier1: null,
								procedureModifier2: null,
								procedureModifier3: null,
								procedureModifier4: null,
								quantity: 0.0,
								quantityString: '',
								quantityQualifierCode: '',
								quantityQualifierCodeDefinition: '',
								serviceTypeCode: '30',
								serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
								additionalIdentifications: [],
								benefitAdditionalInfos: [],

								deliveryPatterns: [],
								relatedEntities: [],
								textMessages: [
									{
										message: 'Test Message',
									},
								],
							},
							{
								authRequired: '',
								benefitInfoCode: 'C',
								benefitInfoCodeDefinition: 'Deductible',
								benefitTimePeriodCode: '23',
								benefitTimePeriodCodeDefinition: 'Calendar Year',
								coverageLevelCode: 'IND',
								coverageLevelCodeDefinition: 'Individual',
								inNetwork: 'Y',
								insuranceDescription: '',
								insuranceTypeCode: '',
								insuranceTypeCodeDefinition: null,
								monetaryAmount: 700.0,
								monetaryAmountString: '700',
								percent: 0.0,
								percentString: '',
								procedureCode: null,
								procedureCodeEnd: null,
								procedureModifier1: null,
								procedureModifier2: null,
								procedureModifier3: null,
								procedureModifier4: null,
								quantity: 0.0,
								quantityString: '',
								quantityQualifierCode: '',
								quantityQualifierCodeDefinition: '',
								serviceTypeCode: '32',
								serviceTypeCodeDefinition: 'Plan Waiting Period',
								additionalIdentifications: [],
								benefitAdditionalInfos: [],

								deliveryPatterns: [],
								relatedEntities: [],
								textMessages: [],
							},
							{
								authRequired: null,
								benefitInfoCode: 'R',
								benefitInfoCodeDefinition: 'Other or Additional Payer',
								benefitTimePeriodCode: null,
								benefitTimePeriodCodeDefinition: null,
								coverageLevelCode: '',
								coverageLevelCodeDefinition: null,
								inNetwork: null,
								insuranceDescription: null,
								insuranceTypeCode: 'OT',
								insuranceTypeCodeDefinition: 'Other',
								monetaryAmount: 0.0,
								monetaryAmountString: null,
								percent: 0.0,
								percentString: null,
								procedureCode: null,
								procedureCodeEnd: null,
								procedureModifier1: null,
								procedureModifier2: null,
								procedureModifier3: null,
								procedureModifier4: null,
								quantity: 0.0,
								quantityString: null,
								quantityQualifierCode: null,
								quantityQualifierCodeDefinition: '',
								serviceTypeCode: '88',
								serviceTypeCodeDefinition: 'Pharmacy',
								additionalIdentifications: [
									{
										identifier: 'S1234 567',
										identifierCode: 'MI',
										identifierCodeDefinition: 'Mill Order Number',
										description: null,
									},
								],
								benefitAdditionalInfos: [],

								deliveryPatterns: [],
								relatedEntities: [
									{
										typeCode: 'PR',
										typeCodeDefinition: 'Payer',
										qualifierCode: null,
										qualifierCodeDefinition: null,
										lastOrOrgName: 'WELLCARE PRESCRIPTION INSURANCE, INC.',
										firstName: null,
										middleName: null,
										nameSuffix: null,
										identifier: null,
										identifierCode: null,
										identifierCodeDefinition: null,
										address1: '8735 Henderson Rd, Renaissance 2',
										address2: null,
										city: 'Tampa',
										state: 'FL',
										zip: '33634',

										providerCodeDefinition: null,
										providerIdentifier: null,
										providerIdentifierCode: null,
										providerIdentifierCodeDefinition: '',
										relatedEntityContacts: [
											{
												Name: '',
												Number1: '(888) 888-9355',
												Number1Code: 'TE',
												Number1CodeDefinition: 'Telephone',
												Number2: 'www.wellcarepdp.com',
												Number2Code: 'UR',
												Number2CodeDefinition: 'Uniform Resource Locator (URL)',
												Number3: null,
												Number3Code: null,
												Number3CodeDefinition: null,
											},
										],
									},
								],
								textMessages: [],
							},
						],
						requestErrors: [],
						createdDate: new Date('2021-02-25T18:18:43.6406131+05:30'),
						subscriber: {
							firstName: 'JTEST',
							middleName: '',
							lastName: 'SHOULDHAVECOVERAGE',
							address1: null,
							address2: null,
							city: null,
							state: null,
							zip: null,
							dateOfBirth: new Date('1952-02-03T00:00:00'),
							dateOfBirthString: new Date('1952-02-03'),
							gender: null,
							identifier: '908080808RW',
							identifierCode: 'MI',
							identifierCodeDefinition: 'Member Identification Number',
							nameSuffix: '',
							dependent: {
								firstName: null,
								middleName: null,
								lastName: null,
								address1: null,
								address2: null,
								nameSuffix: null,
								city: null,
								state: null,
								zip: null,
								dateOfBirth: new Date('0001-01-01T00:00:00'),
								dateOfBirthString: new Date('0001-01-01'),
								gender: null,
								identifier: null,
								identifierCode: null,
								identifierCodeDefinition: null,
								additionalIdentifications: [],
								traceNumberIdentifications: [],
							},

							eligibilityBenefits: [
								{
									authRequired: null,
									benefitInfoCode: '1',
									benefitInfoCodeDefinition: 'Active Coverage',
									benefitTimePeriodCode: null,
									benefitTimePeriodCodeDefinition: null,
									coverageLevelCode: 'EMP',
									coverageLevelCodeDefinition: 'Employee Only',
									inNetwork: null,
									insuranceDescription: 'Medical Plan',
									insuranceTypeCode: 'PS',
									insuranceTypeCodeDefinition: 'Point of Service (POS)',
									monetaryAmount: 0.0,
									monetaryAmountString: null,
									percent: 0.0,
									percentString: null,
									procedureCode: null,
									procedureCodeEnd: null,
									procedureModifier1: null,
									procedureModifier2: null,
									procedureModifier3: null,
									procedureModifier4: null,
									quantity: 0.0,
									quantityString: null,
									quantityQualifierCode: null,
									quantityQualifierCodeDefinition: '',
									serviceTypeCode: '30',
									serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
									additionalIdentifications: [],
									benefitAdditionalInfos: [],

									deliveryPatterns: [],
									relatedEntities: [],
									textMessages: [],
								},
								{
									authRequired: '',
									benefitInfoCode: 'C',
									benefitInfoCodeDefinition: 'Deductible',
									benefitTimePeriodCode: '23',
									benefitTimePeriodCodeDefinition: 'Calendar Year',
									coverageLevelCode: 'IND',
									coverageLevelCodeDefinition: 'Individual',
									inNetwork: 'Y',
									insuranceDescription: '',
									insuranceTypeCode: '',
									insuranceTypeCodeDefinition: null,
									monetaryAmount: 500.0,
									monetaryAmountString: '500',
									percent: 0.0,
									percentString: '',
									procedureCode: null,
									procedureCodeEnd: null,
									procedureModifier1: null,
									procedureModifier2: null,
									procedureModifier3: null,
									procedureModifier4: null,
									quantity: 0.0,
									quantityString: '',
									quantityQualifierCode: '',
									quantityQualifierCodeDefinition: '',
									serviceTypeCode: '30',
									serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
									additionalIdentifications: [],
									benefitAdditionalInfos: [],

									deliveryPatterns: [],
									relatedEntities: [],
									textMessages: [
										{
											message: 'Test Message',
										},
									],
								},
								{
									authRequired: '',
									benefitInfoCode: 'C',
									benefitInfoCodeDefinition: 'Deductible',
									benefitTimePeriodCode: '23',
									benefitTimePeriodCodeDefinition: 'Calendar Year',
									coverageLevelCode: 'IND',
									coverageLevelCodeDefinition: 'Individual',
									inNetwork: 'Y',
									insuranceDescription: '',
									insuranceTypeCode: '',
									insuranceTypeCodeDefinition: null,
									monetaryAmount: 700.0,
									monetaryAmountString: '700',
									percent: 0.0,
									percentString: '',
									procedureCode: null,
									procedureCodeEnd: null,
									procedureModifier1: null,
									procedureModifier2: null,
									procedureModifier3: null,
									procedureModifier4: null,
									quantity: 0.0,
									quantityString: '',
									quantityQualifierCode: '',
									quantityQualifierCodeDefinition: '',
									serviceTypeCode: '32',
									serviceTypeCodeDefinition: 'Plan Waiting Period',
									additionalIdentifications: [],
									benefitAdditionalInfos: [],

									deliveryPatterns: [],
									relatedEntities: [],
									textMessages: [],
								},
								{
									authRequired: null,
									benefitInfoCode: 'R',
									benefitInfoCodeDefinition: 'Other or Additional Payer',
									benefitTimePeriodCode: null,
									benefitTimePeriodCodeDefinition: null,
									coverageLevelCode: '',
									coverageLevelCodeDefinition: null,
									inNetwork: null,
									insuranceDescription: null,
									insuranceTypeCode: 'OT',
									insuranceTypeCodeDefinition: 'Other',
									monetaryAmount: 0.0,
									monetaryAmountString: null,
									percent: 0.0,
									percentString: null,
									procedureCode: null,
									procedureCodeEnd: null,
									procedureModifier1: null,
									procedureModifier2: null,
									procedureModifier3: null,
									procedureModifier4: null,
									quantity: 0.0,
									quantityString: null,
									quantityQualifierCode: null,
									quantityQualifierCodeDefinition: '',
									serviceTypeCode: '88',
									serviceTypeCodeDefinition: 'Pharmacy',
									additionalIdentifications: [
										{
											identifier: 'S1234 567',
											identifierCode: 'MI',
											identifierCodeDefinition: 'Mill Order Number',
											description: null,
										},
									],
									benefitAdditionalInfos: [],

									deliveryPatterns: [],
									relatedEntities: [
										{
											typeCode: 'PR',
											typeCodeDefinition: 'Payer',
											qualifierCode: null,
											qualifierCodeDefinition: null,
											lastOrOrgName: 'WELLCARE PRESCRIPTION INSURANCE, INC.',
											firstName: null,
											middleName: null,
											nameSuffix: null,
											identifier: null,
											identifierCode: null,
											identifierCodeDefinition: null,
											address1: '8735 Henderson Rd, Renaissance 2',
											address2: null,
											city: 'Tampa',
											state: 'FL',
											zip: '33634',

											providerCodeDefinition: null,
											providerIdentifier: null,
											providerIdentifierCode: null,
											providerIdentifierCodeDefinition: '',
											relatedEntityContacts: [
												{
													Name: '',
													Number1: '(888) 888-9355',
													Number1Code: 'TE',
													Number1CodeDefinition: 'Telephone',
													Number2: 'www.wellcarepdp.com',
													Number2Code: 'UR',
													Number2CodeDefinition: 'Uniform Resource Locator (URL)',
													Number3: null,
													Number3Code: null,
													Number3CodeDefinition: null,
												},
											],
										},
									],
									textMessages: [],
								},
							],
							requestErrors: [],
							additionalIdentifications: [],
							traceNumberIdentifications: [
								{
									TraceTypeCode: '2',
									ReferenceIdentification: '976304',
									OriginatingCompanyIdentifier: '9870011234',
									ReferenceSubIdentification: 'PL2053',
								},
								{
									TraceTypeCode: '1',
									ReferenceIdentification: '5677663571',
									OriginatingCompanyIdentifier: '9ABILITYNT',
									ReferenceSubIdentification: null,
								},
							],
							textMessages: [],
						},
					},
					eligibilityResponseTransaction: {
						id: 0,
						eligibilityStatusId: 1,
						zollEligibilityStatusId: 1,
						zollEligibilityStatusDescription: 'Active Coverage',
						payerId: 1,
						raw271: 'ISA*00*          *00*          *ZZ*IVANS-TU-RT    *ZZ*EO-IVANS-RT    *160303*1105*^*00501*505001330*0*P*:~GS*HB*IVANS-TU-RT*EO-IVANS-RT*20160303*1105*505001330*X*005010X279A1~ST*271*150594834*005010X279A1~BHT*0022*11*1196790*20160303*110556~HL*1**20*1~NM1*PR*2*Healthcare One*****PI*10011~HL*2*1*21*1~NM1*1P*2*CUSTOMER*****XX*1849997391~HL*3*2*22*0~TRN*2*976304*9870011234*PL2053~TRN*1*5677663571*9ABILITYNT~NM1*IL*1*SHOULDHAVECOVERAGE*JTEST****MI*908080808RW~DMG*D8*19520203~INS*Y*18*001*25~DTP*472*D8*20151201~EB*1*EMP*30*PS*Medical Plan~EB*C*IND*30***23*500*****Y~DTP*346*D8*20160101~MSG*Test Message~EB*C*IND*32***23*700*****Y~EB*R**88*OT~REF*MI*S1234 567~DTP*292*D8*20130901~LS*2120~NM1*PR*2*WELLCARE PRESCRIPTION INSURANCE, INC.~N3*8735 Henderson Rd, Renaissance 2~N4*Tampa*FL*33634~PER*IC**TE*8888889355*UR*www.wellcarepdp.com~SE*15*150223334~GE*1*505001330~IEA*1*505001330~',
						payer: {
							id: 1,
							code: '10000',
							name: 'Medicare (HETS)',
							payerTypeId: 1,
						},
						eligibilityTransactionStatusMessage: null,
						confidenceScoreReason: null,
						confidenceScoreText: 'High Confidence',
						confidenceScore: {
							id: 1,
							code: 'Y',
							description: 'High Confidence',
							active: true,
							deleted: false,
						},
						receivedSubscriber: {
							id: 1,
							customerEntityId: 1,
							masterIndividualId: 1,
							isMaster: false,
							masterPatientKey: '',
							firstName: 'FirstName1',
							lastName: 'LastName1',
							middleName: '',
							gender: 'M',
							dateOfBirth: new Date('1994-12-09T00:00:00'),
							socialSecurityNumber: '',
							socialSecurityNumberHashed: '',
							address1: 'Address1',
							address2: 'Address2',
							city: 'City1',
							stateCodeId: '15',
							zip: '',
							phoneNumber: '',
							mrn: '',
							clientId: '',
							subscriberId: '',
							deleted: false,
							stateCode: {
								id: 15,
								code: 'IN',
								name: 'Indiana',
								active: true,
							},
						},
					},
				},
				{
					eligibilityResponse: {
						requestErrors: [],
						raw271: '',
						subscriber: {
							firstName: 'Sue5',
							middleName: 'L',
							lastName: 'Vang5',
							address1: '101 Main St',
							address2: 'Suite 102',
							city: 'Any City',
							state: 'NY',
							zip: '10101',
							dateOfBirth: new Date('2000-02-09'),
							dateOfBirthString: new Date('1942-02-26'),
							gender: 'F',
							identifier: '6WY9XX6YY66',
							identifierCode: 'MI',
							identifierCodeDefinition: 'Member Identification Number',
							nameSuffix: '',
							additionalIdentifications: [],
							traceNumberIdentifications: [],
						},
						payer: {
							name: 'Coventry Healthcare - Coventry Health & Life (Nevada)',
							id: 1,
							code: '10000',
							payerTypeId: 1,
						},
						responseDateTime: new Date('0001-01-01T00:00:00'),
						responseDateTimeString: '01-01-0001 12:00:00 AM',

						createdDate: new Date('0001-01-01T00:00:00'),
						eligibilityBenefits: [],
					},
					eligibilityResponseTransaction: {
						id: 0,
						eligibilityStatusId: 1,
						zollEligibilityStatusId: 1,
						zollEligibilityStatusDescription: 'Active Coverage',
						payerId: 6,
						raw271:
							"ISA*00*          *00*          *ZZ*IVANS-MOCK-RT  *ZZ*EO-IVANS-RT    *210215*0012*^*00501*621248000*0*P*:~ GS*HB*IVANS-MOCK-RT*EO-IVANS-RT*20210215*0012*621248000*X*005010X279A1~ ST*271*100621249*005010X279A1~ BHT*0022*11*4139392*20210215*001252~ HL*1**20*1~NM1*PR*2*ABILITY Network - MOCK*****PI*13172~PER*IC*WA State DSHS Provider Relations*TE*8005623022~HL*2*1*21*1~NM1*1P*2*THREE RIVERS HOSP*****XX*1356305395~HL*3*2*22*0~TRN*2*970555*9876543210~TRN*1*621248*9ABILITYCH*REALTIME~TRN*1*3342773945*9ACSEDIGAT~NM1*IL*1*Smith*Mary*K***MI*100121A~REF*HJ*000000000~REF*18*181-HCA EAST~REF*IF*024-OKANOGAN CSO~N3*CY*024-OKANOGAN~DMG*D8*19650115*F~DTP*307*RD8*20140612-20140612~EB*1*IND*1^30^33^35^47^48^50^86^88^98^AL^MH^UC*MC*RAC=1204/BSP=CNP~REF*NQ*025941741~REF*6P*N11*6P - ACES Coverage Group Code~DTP*356*D8*20140401~DTP*357*D8*29991231~MSG*This is the Client's eligibility as of this date, based on information available at this time~EB*A*IND*30*MC*RAC=1204/BSP=CNP***0~EB*B*IND*30*MC*RAC=1204/BSP=CNP**0~EB*C*IND*30*MC*RAC=1204/BSP=CNP**0~EB*R*IND*30*C1~REF*IG*ZNE101181930~DTP*193*D8*20130101~DTP*194*D8*29991231~LS*2120~NM1*PR*2*LIFEWISE*****PI*PH09~NM1*IL*1*VAN WEERDHUIZEN*JUSTIN*T~PER*IC**TE*8007771502~LE*2120~EB*MC*IND**HM~DTP*193*D8*20140401~DTP*194*D8*29991231~LS*2120~NM1*Y2*2*Spokane RSN - Mental Health Services Only*****PI*105021301~PER*IC*SPOKANE RSN - MENTAL HEALTH SERVICES ONLY*TE*8002735864~LE*2120~ SE*44*100621249~ GE*1*621248000~ IEA*1*621248000~ ",
						payer: {
							id: 6,
							code: '10005',
							name: 'Coventry Healthcare - Coventry Health & Life (Nevada)',
							payerTypeId: 3,
						},
						eligibilityTransactionStatusMessage: null,
						confidenceScoreReason: null,
						confidenceScoreText: 'High Confidence',
						confidenceScore: {
							id: 1,
							code: 'Y',
							description: 'High Confidence',
							active: true,
							deleted: false,
						},
						receivedSubscriber: {
							id: 1,
							customerEntityId: 1,
							masterIndividualId: 1,
							isMaster: false,
							masterPatientKey: '',
							firstName: 'FirstName1',
							lastName: 'LastName1',
							middleName: '',
							gender: 'M',
							dateOfBirth: new Date('1994-12-09T00:00:00'),
							socialSecurityNumber: '',
							socialSecurityNumberHashed: '',
							address1: 'Address1',
							address2: 'Address2',
							city: 'City1',
							stateCodeId: '15',
							zip: '',
							phoneNumber: '',
							mrn: '',
							clientId: '',
							subscriberId: '',
							deleted: false,
							stateCode: {
								id: 15,
								code: 'IN',
								name: 'Indiana',
								active: true,
							},
						},
					},

					sections: [
						{
							id: 'sectionPatient',
							loadOrder: 1,
							displayOrder: 1,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
						{
							id: 'sectionServiceCoverage',
							loadOrder: 1,
							displayOrder: 2,
							isFiltered: true,
							summary: {
								serviceTypes: [
									{
										serviceCode: '1',
										serviceCodeDescription: 'Medical Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',
												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '1',
														serviceTypeCodeDefinition: 'Medical Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '30',
										serviceCodeDescription: 'Health Benefit Plan Coverage',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',
												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
													{
														authRequired: null,
														benefitInfoCode: 'A',
														benefitInfoCodeDefinition: 'Co-Insurance',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '',
														percent: 0.0,
														percentString: '0',
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
													{
														authRequired: null,
														benefitInfoCode: 'B',
														benefitInfoCodeDefinition: 'Co-Payment',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '0',
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
													{
														authRequired: null,
														benefitInfoCode: 'C',
														benefitInfoCodeDefinition: 'Deductible',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '0',
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
												],
											},
										],
									},
									{
										serviceCode: '33',
										serviceCodeDescription: 'Chiropractic',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',
												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '33',
														serviceTypeCodeDefinition: 'Chiropractic',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '35',
										serviceCodeDescription: 'Dental Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '35',
														serviceTypeCodeDefinition: 'Dental Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '47',
										serviceCodeDescription: 'Hospital',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '47',
														serviceTypeCodeDefinition: 'Hospital',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '48',
										serviceCodeDescription: 'Hospital - Inpatient',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '48',
														serviceTypeCodeDefinition: 'Hospital - Inpatient',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '50',
										serviceCodeDescription: 'Hospital - Outpatient',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '50',
														serviceTypeCodeDefinition: 'Hospital - Outpatient',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '86',
										serviceCodeDescription: 'Emergency Services',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '86',
														serviceTypeCodeDefinition: 'Emergency Services',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '88',
										serviceCodeDescription: 'Pharmacy',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '88',
														serviceTypeCodeDefinition: 'Pharmacy',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '98',
										serviceCodeDescription: 'Professional (Physician) Visit - Office',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '98',
														serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'AL',
										serviceCodeDescription: 'Vision (Optometry)',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'AL',
														serviceTypeCodeDefinition: 'Vision (Optometry)',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'MH',
										serviceCodeDescription: 'Mental Health',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'MH',
														serviceTypeCodeDefinition: 'Mental Health',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'UC',
										serviceCodeDescription: 'Urgent Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'UC',
														serviceTypeCodeDefinition: 'Urgent Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
								],
								index: 5,
								preferenceKey: 'eligSum5',
								title: 'Service Coverage Overview',
								sections: [
									{
										key: '30',
										value: 'Health Benefit Plan Coverage (30)',
									},
									{
										key: '33',
										value: 'Chiropractic (33)',
									},
									{
										key: '35',
										value: 'Dental Care (35)',
									},
									{
										key: '86',
										value: 'Emergency Services (86)',
									},
									{
										key: '47',
										value: 'Hospital (47)',
									},
									{
										key: '48',
										value: 'Hospital - Inpatient (48)',
									},
									{
										key: '50',
										value: 'Hospital - Outpatient (50)',
									},
									{
										key: '1',
										value: 'Medical Care (1)',
									},
									{
										key: 'MH',
										value: 'Mental Health (MH)',
									},
									{
										key: '88',
										value: 'Pharmacy (88)',
									},
									{
										key: '98',
										value: 'Professional (Physician) Visit - Office (98)',
									},
									{
										key: 'UC',
										value: 'Urgent Care (UC)',
									},
									{
										key: 'AL',
										value: 'Vision (Optometry) (AL)',
									},
								],
								selectedSections: ['30', '33', '35', '86', '47', '48', '50', '1', 'MH', '88', '98', 'UC', 'AL'],
							},
						},
						{
							cEligibilitySummary: {
								eligibilitySummaryStatus: {
									classColor: 'eligibility-summary status-active',
									largeImage: 'Active_Coverage_White-Border.png',
									status: 'Active Coverage',
									description: 'Active Coverage',
								},
								eligibilityResponse: {
									responseDateTime: new Date('0001-01-01T00:00:00'),
									responseDateTimeString: '01-01-0001 12:00:00 AM',
									payer: {
										id: 1,
										code: '10000',
										name: 'Medicare (HETS)',
										payerTypeId: 1,
									},
									raw271:
										"ISA*00*          *00*          *ZZ*IVANS-MOCK-RT  *ZZ*EO-IVANS-RT    *210215*0012*^*00501*621248000*0*P*:~ GS*HB*IVANS-MOCK-RT*EO-IVANS-RT*20210215*0012*621248000*X*005010X279A1~ ST*271*100621249*005010X279A1~ BHT*0022*11*4139392*20210215*001252~ HL*1**20*1~NM1*PR*2*ABILITY Network - MOCK*****PI*13172~PER*IC*WA State DSHS Provider Relations*TE*8005623022~HL*2*1*21*1~NM1*1P*2*THREE RIVERS HOSP*****XX*1356305395~HL*3*2*22*0~TRN*2*970555*9876543210~TRN*1*621248*9ABILITYCH*REALTIME~TRN*1*3342773945*9ACSEDIGAT~NM1*IL*1*Smith*Mary*K***MI*100121A~REF*HJ*000000000~REF*18*181-HCA EAST~REF*IF*024-OKANOGAN CSO~N3*CY*024-OKANOGAN~DMG*D8*19650115*F~DTP*307*RD8*20140612-20140612~EB*1*IND*1^30^33^35^47^48^50^86^88^98^AL^MH^UC*MC*RAC=1204/BSP=CNP~REF*NQ*025941741~REF*6P*N11*6P - ACES Coverage Group Code~DTP*356*D8*20140401~DTP*357*D8*29991231~MSG*This is the Client's eligibility as of this date, based on information available at this time~EB*A*IND*30*MC*RAC=1204/BSP=CNP***0~EB*B*IND*30*MC*RAC=1204/BSP=CNP**0~EB*C*IND*30*MC*RAC=1204/BSP=CNP**0~EB*R*IND*30*C1~REF*IG*ZNE101181930~DTP*193*D8*20130101~DTP*194*D8*29991231~LS*2120~NM1*PR*2*LIFEWISE*****PI*PH09~NM1*IL*1*VAN WEERDHUIZEN*JUSTIN*T~PER*IC**TE*8007771502~LE*2120~EB*MC*IND**HM~DTP*193*D8*20140401~DTP*194*D8*29991231~LS*2120~NM1*Y2*2*Spokane RSN - Mental Health Services Only*****PI*105021301~PER*IC*SPOKANE RSN - MENTAL HEALTH SERVICES ONLY*TE*8002735864~LE*2120~ SE*44*100621249~ GE*1*621248000~ IEA*1*621248000~ ",
									eligibilityBenefits: [
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '1',
											serviceTypeCodeDefinition: 'Medical Care',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '33',
											serviceTypeCodeDefinition: 'Chiropractic',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '35',
											serviceTypeCodeDefinition: 'Dental Care',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '47',
											serviceTypeCodeDefinition: 'Hospital',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '48',
											serviceTypeCodeDefinition: 'Hospital - Inpatient',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '50',
											serviceTypeCodeDefinition: 'Hospital - Outpatient',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '86',
											serviceTypeCodeDefinition: 'Emergency Services',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '88',
											serviceTypeCodeDefinition: 'Pharmacy',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '98',
											serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'AL',
											serviceTypeCodeDefinition: 'Vision (Optometry)',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'MH',
											serviceTypeCodeDefinition: 'Mental Health',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'UC',
											serviceTypeCodeDefinition: 'Urgent Care',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'A',
											benefitInfoCodeDefinition: 'Co-Insurance',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: '',
											percent: 0.0,
											percentString: '0',
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: '0',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [],
										},
										{
											authRequired: null,
											benefitInfoCode: 'C',
											benefitInfoCodeDefinition: 'Deductible',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: '0',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [],
										},
										{
											authRequired: null,
											benefitInfoCode: 'R',
											benefitInfoCodeDefinition: 'Other or Additional Payer',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: null,
											insuranceTypeCode: 'C1',
											insuranceTypeCodeDefinition: 'Commercial',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [
												{
													identifier: 'ZNE101181930',
													identifierCode: 'IG',
													identifierCodeDefinition: 'Insurance Policy Number',
													description: null,
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'LIFEWISE',
													firstName: '',
													middleName: '',
													nameSuffix: '',
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: 'PH09',
													providerIdentifierCode: 'PI',
													providerIdentifierCodeDefinition: 'Payer Identification',
													relatedEntityContacts: [],
												},
											],
											textMessages: [],
										},
										{
											authRequired: null,
											benefitInfoCode: 'R',
											benefitInfoCodeDefinition: 'Other or Additional Payer',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: null,
											insuranceTypeCode: 'C1',
											insuranceTypeCodeDefinition: 'Commercial',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [
												{
													identifier: 'ZNE101181930',
													identifierCode: 'IG',
													identifierCodeDefinition: 'Insurance Policy Number',
													description: null,
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'IL',
													typeCodeDefinition: 'Insured or Subscriber',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'VAN WEERDHUIZEN',
													firstName: 'JUSTIN',
													middleName: 'T',
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [
														{
															Name: '',
															Number1: '(800) 777-1502',
															Number1Code: 'TE',
															Number1CodeDefinition: 'Telephone',
															Number2: null,
															Number2Code: null,
															Number2CodeDefinition: null,
															Number3: null,
															Number3Code: null,
															Number3CodeDefinition: null,
														},
													],
												},
											],
											textMessages: [],
										},
										{
											authRequired: null,
											benefitInfoCode: 'MC',
											benefitInfoCodeDefinition: 'Managed Care Coordinator',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: null,
											insuranceTypeCode: 'HM',
											insuranceTypeCodeDefinition: 'Health Maintenance Organization (HMO)',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: null,
											serviceTypeCodeDefinition: null,
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'Y2',
													typeCodeDefinition: 'Managed Care Organization',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Spokane RSN - Mental Health Services Only',
													firstName: '',
													middleName: '',
													nameSuffix: '',
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: '105021301',
													providerIdentifierCode: 'PI',
													providerIdentifierCodeDefinition: 'Payer Identification',
													relatedEntityContacts: [
														{
															Name: 'SPOKANE RSN - MENTAL HEALTH SERVICES ONLY',
															Number1: '(800) 273-5864',
															Number1Code: 'TE',
															Number1CodeDefinition: 'Telephone',
															Number2: null,
															Number2Code: null,
															Number2CodeDefinition: null,
															Number3: null,
															Number3Code: null,
															Number3CodeDefinition: null,
														},
													],
												},
											],
											textMessages: [],
										},
									],
									requestErrors: [],
									createdDate: new Date('2021-02-25T14:02:05.8333702+05:30'),
									subscriber: {
										firstName: 'Mary',
										middleName: 'K',
										lastName: 'Smith',
										address1: 'CY',
										address2: '024-OKANOGAN',
										city: null,
										state: null,
										zip: null,
										dateOfBirth: new Date('1965-01-15T00:00:00'),
										dateOfBirthString: new Date('1965-01-15'),
										gender: 'F',
										identifier: '100121A',
										identifierCode: 'MI',
										identifierCodeDefinition: 'Member Identification Number',
										nameSuffix: '',
										dependent: {
											firstName: null,
											middleName: null,
											lastName: null,
											address1: null,
											address2: null,
											nameSuffix: null,
											city: null,
											state: null,
											zip: null,
											dateOfBirth: new Date('0001-01-01T00:00:00'),
											dateOfBirthString: new Date('0001-01-01'),
											gender: null,
											identifier: null,
											identifierCode: null,
											identifierCodeDefinition: null,
											additionalIdentifications: [],
											traceNumberIdentifications: [],
										},

										eligibilityBenefits: [
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '1',
												serviceTypeCodeDefinition: 'Medical Care',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '33',
												serviceTypeCodeDefinition: 'Chiropractic',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '35',
												serviceTypeCodeDefinition: 'Dental Care',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '47',
												serviceTypeCodeDefinition: 'Hospital',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '48',
												serviceTypeCodeDefinition: 'Hospital - Inpatient',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '50',
												serviceTypeCodeDefinition: 'Hospital - Outpatient',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '86',
												serviceTypeCodeDefinition: 'Emergency Services',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '88',
												serviceTypeCodeDefinition: 'Pharmacy',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '98',
												serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: 'AL',
												serviceTypeCodeDefinition: 'Vision (Optometry)',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: 'MH',
												serviceTypeCodeDefinition: 'Mental Health',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: 'UC',
												serviceTypeCodeDefinition: 'Urgent Care',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: 'A',
												benefitInfoCodeDefinition: 'Co-Insurance',
												benefitTimePeriodCode: '',
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: '',
												percent: 0.0,
												percentString: '0',
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [],
											},
											{
												authRequired: null,
												benefitInfoCode: 'B',
												benefitInfoCodeDefinition: 'Co-Payment',
												benefitTimePeriodCode: '',
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: '0',
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [],
											},
											{
												authRequired: null,
												benefitInfoCode: 'C',
												benefitInfoCodeDefinition: 'Deductible',
												benefitTimePeriodCode: '',
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: '0',
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [],
											},
											{
												authRequired: null,
												benefitInfoCode: 'R',
												benefitInfoCodeDefinition: 'Other or Additional Payer',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: null,
												insuranceTypeCode: 'C1',
												insuranceTypeCodeDefinition: 'Commercial',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [
													{
														identifier: 'ZNE101181930',
														identifierCode: 'IG',
														identifierCodeDefinition: 'Insurance Policy Number',
														description: null,
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [
													{
														typeCode: 'PR',
														typeCodeDefinition: 'Payer',
														qualifierCode: null,
														qualifierCodeDefinition: null,
														lastOrOrgName: 'LIFEWISE',
														firstName: '',
														middleName: '',
														nameSuffix: '',
														identifier: null,
														identifierCode: null,
														identifierCodeDefinition: null,
														address1: null,
														address2: null,
														city: null,
														state: null,
														zip: null,

														providerCodeDefinition: null,
														providerIdentifier: 'PH09',
														providerIdentifierCode: 'PI',
														providerIdentifierCodeDefinition: 'Payer Identification',
														relatedEntityContacts: [],
													},
												],
												textMessages: [],
											},
											{
												authRequired: null,
												benefitInfoCode: 'R',
												benefitInfoCodeDefinition: 'Other or Additional Payer',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: null,
												insuranceTypeCode: 'C1',
												insuranceTypeCodeDefinition: 'Commercial',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [
													{
														identifier: 'ZNE101181930',
														identifierCode: 'IG',
														identifierCodeDefinition: 'Insurance Policy Number',
														description: null,
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [
													{
														typeCode: 'IL',
														typeCodeDefinition: 'Insured or Subscriber',
														qualifierCode: null,
														qualifierCodeDefinition: null,
														lastOrOrgName: 'VAN WEERDHUIZEN',
														firstName: 'JUSTIN',
														middleName: 'T',
														nameSuffix: null,
														identifier: null,
														identifierCode: null,
														identifierCodeDefinition: null,
														address1: null,
														address2: null,
														city: null,
														state: null,
														zip: null,

														providerCodeDefinition: null,
														providerIdentifier: null,
														providerIdentifierCode: null,
														providerIdentifierCodeDefinition: '',
														relatedEntityContacts: [
															{
																Name: '',
																Number1: '(800) 777-1502',
																Number1Code: 'TE',
																Number1CodeDefinition: 'Telephone',
																Number2: null,
																Number2Code: null,
																Number2CodeDefinition: null,
																Number3: null,
																Number3Code: null,
																Number3CodeDefinition: null,
															},
														],
													},
												],
												textMessages: [],
											},
											{
												authRequired: null,
												benefitInfoCode: 'MC',
												benefitInfoCodeDefinition: 'Managed Care Coordinator',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: null,
												insuranceTypeCode: 'HM',
												insuranceTypeCodeDefinition: 'Health Maintenance Organization (HMO)',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: null,
												serviceTypeCodeDefinition: null,
												additionalIdentifications: [],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [
													{
														typeCode: 'Y2',
														typeCodeDefinition: 'Managed Care Organization',
														qualifierCode: null,
														qualifierCodeDefinition: null,
														lastOrOrgName: 'Spokane RSN - Mental Health Services Only',
														firstName: '',
														middleName: '',
														nameSuffix: '',
														identifier: null,
														identifierCode: null,
														identifierCodeDefinition: null,
														address1: null,
														address2: null,
														city: null,
														state: null,
														zip: null,

														providerCodeDefinition: null,
														providerIdentifier: '105021301',
														providerIdentifierCode: 'PI',
														providerIdentifierCodeDefinition: 'Payer Identification',
														relatedEntityContacts: [
															{
																Name: 'SPOKANE RSN - MENTAL HEALTH SERVICES ONLY',
																Number1: '(800) 273-5864',
																Number1Code: 'TE',
																Number1CodeDefinition: 'Telephone',
																Number2: null,
																Number2Code: null,
																Number2CodeDefinition: null,
																Number3: null,
																Number3Code: null,
																Number3CodeDefinition: null,
															},
														],
													},
												],
												textMessages: [],
											},
										],
										requestErrors: [],
										additionalIdentifications: [
											{
												Identifier: '000000000',
												IdentifierCode: 'HJ',
												IdentifierCodeDefinition: 'Identity Card Number',
												Description: null,
											},
											{
												Identifier: '181-HCA EAST',
												IdentifierCode: '18',
												IdentifierCodeDefinition: 'Plan Number',
												Description: null,
											},
											{
												Identifier: '024-OKANOGAN CSO',
												IdentifierCode: 'IF',
												IdentifierCodeDefinition: 'Issue Number',
												Description: null,
											},
										],
										traceNumberIdentifications: [
											{
												TraceTypeCode: '2',
												ReferenceIdentification: '970555',
												OriginatingCompanyIdentifier: '9876543210',
												ReferenceSubIdentification: null,
											},
											{
												TraceTypeCode: '1',
												ReferenceIdentification: '621248',
												OriginatingCompanyIdentifier: '9ABILITYCH',
												ReferenceSubIdentification: 'REALTIME',
											},
											{
												TraceTypeCode: '1',
												ReferenceIdentification: '3342773945',
												OriginatingCompanyIdentifier: '9ACSEDIGAT',
												ReferenceSubIdentification: null,
											},
										],
										textMessages: [],
									},
								},
								planName: 'LPPO-UNITEDHEALTHCARE NURSING HOME PLAN (PPO SNP)',
								effectiveDate: '6/1/2013',
								planNetwork: [],
								identifiers: [
									{
										item1: 'Sub. Group Number:',
										item2: '660415',
									},
								],
							},
							id: 'sectionCEligibility',
							loadOrder: 2,
							displayOrder: 3,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},

						{
							eligibilityResponse: {
								raw271: '',
								responseDateTime: new Date('2021-02-26T15:43:45'),
								responseDateTimeString: '02-26-2021 03:43:45 PM',
								payer: {
									id: 1,
									code: '10000',
									name: 'Medicare (HETS)',
									payerTypeId: 1,
								},

								eligibilityBenefits: [
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '30',
										serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '86',
										serviceTypeCodeDefinition: 'Emergency Services',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: 'AL',
										serviceTypeCodeDefinition: 'Vision (Optometry)',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '47',
										serviceTypeCodeDefinition: 'Hospital',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '1',
										serviceTypeCodeDefinition: 'Medical Care',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: 'UC',
										serviceTypeCodeDefinition: 'Urgent Care',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: 'MH',
										serviceTypeCodeDefinition: 'Mental Health',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '88',
										serviceTypeCodeDefinition: 'Pharmacy',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '48',
										serviceTypeCodeDefinition: 'Hospital - Inpatient',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '35',
										serviceTypeCodeDefinition: 'Dental Care',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '98',
										serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '50',
										serviceTypeCodeDefinition: 'Hospital - Outpatient',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'B',
										benefitInfoCodeDefinition: 'Co-Payment',
										benefitTimePeriodCode: '',
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: '',
										insuranceTypeCode: '',
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 0.0,
										monetaryAmountString: '0',
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '88',
										serviceTypeCodeDefinition: 'Pharmacy',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [],
										textMessages: [
											{
												message: '$1.00 for Generic or $3.00 for brand name',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'B',
										benefitInfoCodeDefinition: 'Co-Payment',
										benefitTimePeriodCode: '',
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: '',
										insuranceTypeCode: '',
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 0.0,
										monetaryAmountString: '0',
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '48',
										serviceTypeCodeDefinition: 'Hospital - Inpatient',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [],
										textMessages: [
											{
												message: '$10.00 per covered day or 50% of the average allowable daily rate whichever is less. The average allowable daily rate can be calculated using the Total allowed charge for the entire stay and divide by the',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'B',
										benefitInfoCodeDefinition: 'Co-Payment',
										benefitTimePeriodCode: '',
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: '',
										insuranceTypeCode: '',
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 0.0,
										monetaryAmountString: '0',
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '35',
										serviceTypeCodeDefinition: 'Dental Care',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [],
										textMessages: [
											{
												message: 'Children Only. Adults with a concurrent Medical Condition - Please see Provider Manual',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'B',
										benefitInfoCodeDefinition: 'Co-Payment',
										benefitTimePeriodCode: '',
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: '',
										insuranceTypeCode: '',
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 2.0,
										monetaryAmountString: '2',
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '98',
										serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [],
										textMessages: [
											{
												message: 'Per visit',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'B',
										benefitInfoCodeDefinition: 'Co-Payment',
										benefitTimePeriodCode: '',
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: '',
										insuranceTypeCode: '',
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 3.0,
										monetaryAmountString: '3',
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '50',
										serviceTypeCodeDefinition: 'Hospital - Outpatient',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [],
										textMessages: [
											{
												message: 'Per visit',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'MC',
										benefitInfoCodeDefinition: 'Managed Care Coordinator',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: '',
										coverageLevelCodeDefinition: null,
										inNetwork: null,
										insuranceDescription: null,
										insuranceTypeCode: null,
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: null,
										serviceTypeCodeDefinition: null,
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: '1P',
												typeCodeDefinition: 'Provider',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'COLORADO HEALTH NETWORKS',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [
													{
														Name: '',
														Number1: '(800) 804-5008',
														Number1Code: 'TE',
														Number1CodeDefinition: 'Telephone',
														Number2: null,
														Number2Code: null,
														Number2CodeDefinition: null,
														Number3: null,
														Number3Code: null,
														Number3CodeDefinition: null,
													},
												],
											},
										],
										textMessages: [
											{
												message: 'MHPROV Services',
											},
										],
									},
								],
								requestErrors: [],
								createdDate: new Date('0001-01-01T00:00:00'),
								subscriber: {
									firstName: 'Jane',
									middleName: 'P',
									lastName: 'Shaw',
									address1: '101 Main St',
									address2: null,
									city: 'Any City',
									state: 'CO',
									zip: '81321-9187',
									dateOfBirth: new Date('1947-11-24T00:00:00'),
									dateOfBirthString: new Date('1947-11-24'),
									gender: 'F',
									identifier: '100096A',
									identifierCode: 'MI',
									identifierCodeDefinition: 'Member Identification Number',
									nameSuffix: '',
									dependent: {
										firstName: null,
										middleName: null,
										lastName: null,
										address1: null,
										address2: null,
										nameSuffix: null,
										city: null,
										state: null,
										zip: null,
										dateOfBirth: new Date('0001-01-01T00:00:00'),
										dateOfBirthString: new Date('0001-01-01'),
										gender: null,
										identifier: null,
										identifierCode: null,
										identifierCodeDefinition: null,
										additionalIdentifications: [],
										traceNumberIdentifications: [],
									},

									eligibilityBenefits: [
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '86',
											serviceTypeCodeDefinition: 'Emergency Services',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'AL',
											serviceTypeCodeDefinition: 'Vision (Optometry)',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '47',
											serviceTypeCodeDefinition: 'Hospital',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '1',
											serviceTypeCodeDefinition: 'Medical Care',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'UC',
											serviceTypeCodeDefinition: 'Urgent Care',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'MH',
											serviceTypeCodeDefinition: 'Mental Health',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '88',
											serviceTypeCodeDefinition: 'Pharmacy',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '48',
											serviceTypeCodeDefinition: 'Hospital - Inpatient',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '35',
											serviceTypeCodeDefinition: 'Dental Care',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '98',
											serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '50',
											serviceTypeCodeDefinition: 'Hospital - Outpatient',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: '',
											insuranceTypeCode: '',
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 0.0,
											monetaryAmountString: '0',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '88',
											serviceTypeCodeDefinition: 'Pharmacy',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: '$1.00 for Generic or $3.00 for brand name',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: '',
											insuranceTypeCode: '',
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 0.0,
											monetaryAmountString: '0',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '48',
											serviceTypeCodeDefinition: 'Hospital - Inpatient',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: '$10.00 per covered day or 50% of the average allowable daily rate whichever is less. The average allowable daily rate can be calculated using the Total allowed charge for the entire stay and divide by the',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: '',
											insuranceTypeCode: '',
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 0.0,
											monetaryAmountString: '0',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '35',
											serviceTypeCodeDefinition: 'Dental Care',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: 'Children Only. Adults with a concurrent Medical Condition - Please see Provider Manual',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: '',
											insuranceTypeCode: '',
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 2.0,
											monetaryAmountString: '2',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '98',
											serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: 'Per visit',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: '',
											insuranceTypeCode: '',
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 3.0,
											monetaryAmountString: '3',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '50',
											serviceTypeCodeDefinition: 'Hospital - Outpatient',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: 'Per visit',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'MC',
											benefitInfoCodeDefinition: 'Managed Care Coordinator',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: '',
											coverageLevelCodeDefinition: null,
											inNetwork: null,
											insuranceDescription: null,
											insuranceTypeCode: null,
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: null,
											serviceTypeCodeDefinition: null,
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: '1P',
													typeCodeDefinition: 'Provider',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'COLORADO HEALTH NETWORKS',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [
														{
															Name: '',
															Number1: '(800) 804-5008',
															Number1Code: 'TE',
															Number1CodeDefinition: 'Telephone',
															Number2: null,
															Number2Code: null,
															Number2CodeDefinition: null,
															Number3: null,
															Number3Code: null,
															Number3CodeDefinition: null,
														},
													],
												},
											],
											textMessages: [
												{
													message: 'MHPROV Services',
												},
											],
										},
									],
									requestErrors: [],
									additionalIdentifications: [],
									traceNumberIdentifications: [
										{
											TraceTypeCode: '2',
											ReferenceIdentification: '970555',
											OriginatingCompanyIdentifier: '9876543210',
											ReferenceSubIdentification: null,
										},
										{
											TraceTypeCode: '1',
											ReferenceIdentification: '644325',
											OriginatingCompanyIdentifier: '9ABILITYCH',
											ReferenceSubIdentification: 'REALTIME',
										},
										{
											TraceTypeCode: '1',
											ReferenceIdentification: '000000006454550',
											OriginatingCompanyIdentifier: '977016',
											ReferenceSubIdentification: null,
										},
									],
									textMessages: [],
								},
							},
							id: 'sectionBenefitInformation',
							loadOrder: 5,
							displayOrder: 6,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},

						{
							id: 'sectionCServiceType',
							loadOrder: 7,
							displayOrder: 8,
							isFiltered: true,
							summary: {
								serviceTypes: [
									{
										serviceCode: '1',
										serviceCodeDescription: 'Medical Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '1',
														serviceTypeCodeDefinition: 'Medical Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '30',
										serviceCodeDescription: 'Health Benefit Plan Coverage',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
													{
														authRequired: null,
														benefitInfoCode: 'A',
														benefitInfoCodeDefinition: 'Co-Insurance',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '',
														percent: 0.0,
														percentString: '0',
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
													{
														authRequired: null,
														benefitInfoCode: 'B',
														benefitInfoCodeDefinition: 'Co-Payment',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '0',
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
													{
														authRequired: null,
														benefitInfoCode: 'C',
														benefitInfoCodeDefinition: 'Deductible',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '0',
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '33',
										serviceCodeDescription: 'Chiropractic',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '33',
														serviceTypeCodeDefinition: 'Chiropractic',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '35',
										serviceCodeDescription: 'Dental Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '35',
														serviceTypeCodeDefinition: 'Dental Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '47',
										serviceCodeDescription: 'Hospital',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '47',
														serviceTypeCodeDefinition: 'Hospital',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '48',
										serviceCodeDescription: 'Hospital - Inpatient',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '48',
														serviceTypeCodeDefinition: 'Hospital - Inpatient',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '50',
										serviceCodeDescription: 'Hospital - Outpatient',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '50',
														serviceTypeCodeDefinition: 'Hospital - Outpatient',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '86',
										serviceCodeDescription: 'Emergency Services',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '86',
														serviceTypeCodeDefinition: 'Emergency Services',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '88',
										serviceCodeDescription: 'Pharmacy',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '88',
														serviceTypeCodeDefinition: 'Pharmacy',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '98',
										serviceCodeDescription: 'Professional (Physician) Visit - Office',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '98',
														serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'AL',
										serviceCodeDescription: 'Vision (Optometry)',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'AL',
														serviceTypeCodeDefinition: 'Vision (Optometry)',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'MH',
										serviceCodeDescription: 'Mental Health',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'MH',
														serviceTypeCodeDefinition: 'Mental Health',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'UC',
										serviceCodeDescription: 'Urgent Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'UC',
														serviceTypeCodeDefinition: 'Urgent Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
												cInsuranceBenefits: [
													{
														code: 'X',
														description: 'Health Care Facility',
														lines: [
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
																	},
																],
															},
															{
																sections: [
																	{
																		isBold: false,
																		value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
																	},
																],
															},
														],
													},
												],
											},
										],
									},
								],
								index: 5,
								preferenceKey: 'eligSum5',
								title: 'Service Types',
								sections: [
									{
										key: '30',
										value: 'Health Benefit Plan Coverage (30)',
									},
									{
										key: '33',
										value: 'Chiropractic (33)',
									},
									{
										key: '35',
										value: 'Dental Care (35)',
									},
									{
										key: '86',
										value: 'Emergency Services (86)',
									},
									{
										key: '47',
										value: 'Hospital (47)',
									},
									{
										key: '48',
										value: 'Hospital - Inpatient (48)',
									},
									{
										key: '50',
										value: 'Hospital - Outpatient (50)',
									},
									{
										key: '1',
										value: 'Medical Care (1)',
									},
									{
										key: 'MH',
										value: 'Mental Health (MH)',
									},
									{
										key: '88',
										value: 'Pharmacy (88)',
									},
									{
										key: '98',
										value: 'Professional (Physician) Visit - Office (98)',
									},
									{
										key: 'UC',
										value: 'Urgent Care (UC)',
									},
									{
										key: 'AL',
										value: 'Vision (Optometry) (AL)',
									},
								],
								selectedSections: ['30', '33', '35', '86', '47', '48', '50', '1', 'MH', '88', '98', 'UC', 'AL'],
							},
						},
						{
							id: '1',
							loadOrder: 0,
							displayOrder: 0,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
						{
							mcoStatusAlertSectionViewModels: [
								{
									id: 1,
									cLineList: [
										{
											sections: [
												{
													isBold: false,
													value: 'FullName',
												},
												{
													isBold: false,
													value: 'NETWORK HEALTH LLC',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Address',
												},
												{
													isBold: false,
													value: '101 STATION LNDG, MEDFORD, MA 02155',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Telephone',
												},
												{
													isBold: false,
													value: '(888) 257-1985',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'PlanDescription',
												},
												{
													isBold: false,
													value: 'INTEGRATED CARE ORGANIZATIONS',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'ServiceType',
												},
												{
													isBold: false,
													value: 'Health Benefit Plan Coverage',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'StartDate',
												},
												{
													isBold: false,
													value: '10/2/2015',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'EndDate',
												},
												{
													isBold: false,
													value: '10/2/2015',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Message',
												},
												{
													isBold: false,
													value: '669 One Care. Network Health member. For medical, behavioral health, and long-term services and support services, call 1-888-257-1985.',
												},
											],
										},
									],
								},
							],
							id: 'sectionMCOStatusAlert',
							loadOrder: 3,
							displayOrder: 4,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
						{
							pcpSectionViewModels: [
								{
									id: 1,
									cLineList: [
										{
											sections: [
												{
													isBold: false,
													value: 'PolicyNumber',
												},
												{
													isBold: false,
													value: 'S14569',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'FullName',
												},
												{
													isBold: false,
													value: 'Aetna',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Address',
												},
												{
													isBold: false,
													value: 'Bowman ST West Chicago, CT, 678799',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Telephone',
												},
												{
													isBold: false,
													value: '(800) 998-9789',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'PlanDescription',
												},
												{
													isBold: false,
													value: 'Master Policy',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'ServiceType',
												},
												{
													isBold: false,
													value: 'Health Benefit Plan Coverage',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'StartDate',
												},
												{
													isBold: false,
													value: '8/8/2014',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Message',
												},
												{
													isBold: false,
													value: 'Policy Term',
												},
											],
										},
									],
								},
							],
							id: 'sectionPCP',
							loadOrder: 4,
							displayOrder: 5,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
						{
							otherPayersSectionViewModels: [
								{
									id: 1,
									cLineList: [
										{
											sections: [
												{
													isBold: false,
													value: 'Insurance Type',
												},
												{
													isBold: false,
													value: 'Life Insurance',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Plan Description',
												},
												{
													isBold: false,
													value: 'Master Policy',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Service Type',
												},
												{
													isBold: false,
													value: 'Health Benefit Plan Coverage',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Insurance Policy Number',
												},
												{
													isBold: false,
													value: 'S14569',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Name',
												},
												{
													isBold: false,
													value: 'Aetna',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Address',
												},
												{
													isBold: false,
													value: 'Bowman ST',
												},
												{
													isBold: false,
													value: ' West Chicago',
												},
												{
													isBold: false,
													value: ', CT',
												},
												{
													isBold: false,
													value: ', 678799',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'StartDate',
												},
												{
													isBold: false,
													value: '8/8/2014',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'EndDate',
												},
												{
													isBold: false,
													value: '9/9/2014',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Message',
												},
												{
													isBold: false,
													value: 'Policy Term',
												},
											],
										},
									],
								},
							],
							id: 'sectionOtherPayer',
							loadOrder: 6,
							displayOrder: 7,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
					],
				},
				{
					eligibilityResponse: {
						requestErrors: [],
						raw271: '',
						subscriber: {
							firstName: 'Sue',
							middleName: 'L',
							lastName: 'Vang',
							address1: 'Main St',
							address2: 'Suite 103',
							city: 'Any City',
							state: 'NY',
							zip: '10101',
							dateOfBirth: new Date('2002-02-09'),
							dateOfBirthString: new Date('1922-02-26'),
							gender: 'F',
							identifier: '6WY9XX2YY66',
							identifierCode: 'MI',
							identifierCodeDefinition: 'Member Identification Number',
							nameSuffix: '',
							additionalIdentifications: [],
							traceNumberIdentifications: [],
						},
						payer: {
							name: 'Coventry Healthcare - Coventry Health & Life (Nevada)',
							id: 1,
							code: '10000',

							payerTypeId: 1,
						},
						responseDateTime: new Date('0001-01-01T00:00:00'),
						responseDateTimeString: '01-01-0001 12:00:00 AM',

						createdDate: new Date('0001-01-01T00:00:00'),
						eligibilityBenefits: [],
					},
					eligibilityResponseTransaction: {
						id: 0,
						eligibilityStatusId: 1,
						zollEligibilityStatusId: 1,
						zollEligibilityStatusDescription: 'Active Coverage',
						payerId: 6,
						raw271:
							"ISA*00*          *00*          *ZZ*IVANS-MOCK-RT  *ZZ*EO-IVANS-RT    *210215*0012*^*00501*621248000*0*P*:~ GS*HB*IVANS-MOCK-RT*EO-IVANS-RT*20210215*0012*621248000*X*005010X279A1~ ST*271*100621249*005010X279A1~ BHT*0022*11*4139392*20210215*001252~ HL*1**20*1~NM1*PR*2*ABILITY Network - MOCK*****PI*13172~PER*IC*WA State DSHS Provider Relations*TE*8005623022~HL*2*1*21*1~NM1*1P*2*THREE RIVERS HOSP*****XX*1356305395~HL*3*2*22*0~TRN*2*970555*9876543210~TRN*1*621248*9ABILITYCH*REALTIME~TRN*1*3342773945*9ACSEDIGAT~NM1*IL*1*Smith*Mary*K***MI*100121A~REF*HJ*000000000~REF*18*181-HCA EAST~REF*IF*024-OKANOGAN CSO~N3*CY*024-OKANOGAN~DMG*D8*19650115*F~DTP*307*RD8*20140612-20140612~EB*1*IND*1^30^33^35^47^48^50^86^88^98^AL^MH^UC*MC*RAC=1204/BSP=CNP~REF*NQ*025941741~REF*6P*N11*6P - ACES Coverage Group Code~DTP*356*D8*20140401~DTP*357*D8*29991231~MSG*This is the Client's eligibility as of this date, based on information available at this time~EB*A*IND*30*MC*RAC=1204/BSP=CNP***0~EB*B*IND*30*MC*RAC=1204/BSP=CNP**0~EB*C*IND*30*MC*RAC=1204/BSP=CNP**0~EB*R*IND*30*C1~REF*IG*ZNE101181930~DTP*193*D8*20130101~DTP*194*D8*29991231~LS*2120~NM1*PR*2*LIFEWISE*****PI*PH09~NM1*IL*1*VAN WEERDHUIZEN*JUSTIN*T~PER*IC**TE*8007771502~LE*2120~EB*MC*IND**HM~DTP*193*D8*20140401~DTP*194*D8*29991231~LS*2120~NM1*Y2*2*Spokane RSN - Mental Health Services Only*****PI*105021301~PER*IC*SPOKANE RSN - MENTAL HEALTH SERVICES ONLY*TE*8002735864~LE*2120~ SE*44*100621249~ GE*1*621248000~ IEA*1*621248000~ ",
						payer: {
							id: 6,
							code: '10005',
							name: 'Coventry Healthcare - Coventry Health & Life (Nevada)',
							payerTypeId: 3,
						},
						eligibilityTransactionStatusMessage: null,
						confidenceScoreReason: null,
						confidenceScoreText: 'High Confidence',
						confidenceScore: {
							id: 1,
							code: 'Y',
							description: 'High Confidence',
							active: true,
							deleted: false,
						},
						receivedSubscriber: {
							id: 1,
							customerEntityId: 1,
							masterIndividualId: 1,
							isMaster: false,
							masterPatientKey: '',
							firstName: 'FirstName1',
							lastName: 'LastName1',
							middleName: '',
							gender: 'M',
							dateOfBirth: new Date('1992-12-09T00:00:00'),
							socialSecurityNumber: '',
							socialSecurityNumberHashed: '',
							address1: 'Address1',
							address2: 'Address2',
							city: 'City1',
							stateCodeId: '15',
							zip: '',
							phoneNumber: '',
							mrn: '',
							clientId: '',
							subscriberId: '',
							deleted: false,
							stateCode: {
								id: 15,
								code: 'IN',
								name: 'Indiana',
								active: true,
							},
						},
					},
					sections: [
						{
							id: 'sectionPatient',
							loadOrder: 1,
							displayOrder: 1,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
						{
							id: 'sectionServiceCoverage',
							loadOrder: 1,
							displayOrder: 2,
							isFiltered: true,
							summary: {
								serviceTypes: [
									{
										serviceCode: '1',
										serviceCodeDescription: 'Medical Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',
												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '1',
														serviceTypeCodeDefinition: 'Medical Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '30',
										serviceCodeDescription: 'Health Benefit Plan Coverage',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',
												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
													{
														authRequired: null,
														benefitInfoCode: 'A',
														benefitInfoCodeDefinition: 'Co-Insurance',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '',
														percent: 0.0,
														percentString: '0',
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
													{
														authRequired: null,
														benefitInfoCode: 'B',
														benefitInfoCodeDefinition: 'Co-Payment',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '0',
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
													{
														authRequired: null,
														benefitInfoCode: 'C',
														benefitInfoCodeDefinition: 'Deductible',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '0',
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
												],
											},
										],
									},
									{
										serviceCode: '33',
										serviceCodeDescription: 'Chiropractic',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',
												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '33',
														serviceTypeCodeDefinition: 'Chiropractic',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '35',
										serviceCodeDescription: 'Dental Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '35',
														serviceTypeCodeDefinition: 'Dental Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '47',
										serviceCodeDescription: 'Hospital',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '47',
														serviceTypeCodeDefinition: 'Hospital',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '48',
										serviceCodeDescription: 'Hospital - Inpatient',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',
												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '48',
														serviceTypeCodeDefinition: 'Hospital - Inpatient',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '50',
										serviceCodeDescription: 'Hospital - Outpatient',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '50',
														serviceTypeCodeDefinition: 'Hospital - Outpatient',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '86',
										serviceCodeDescription: 'Emergency Services',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '86',
														serviceTypeCodeDefinition: 'Emergency Services',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '88',
										serviceCodeDescription: 'Pharmacy',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '88',
														serviceTypeCodeDefinition: 'Pharmacy',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '98',
										serviceCodeDescription: 'Professional (Physician) Visit - Office',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '98',
														serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'AL',
										serviceCodeDescription: 'Vision (Optometry)',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'AL',
														serviceTypeCodeDefinition: 'Vision (Optometry)',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'MH',
										serviceCodeDescription: 'Mental Health',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'MH',
														serviceTypeCodeDefinition: 'Mental Health',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'UC',
										serviceCodeDescription: 'Urgent Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'UC',
														serviceTypeCodeDefinition: 'Urgent Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
								],
								index: 5,
								preferenceKey: 'eligSum5',
								title: 'Service Coverage Overview',
								sections: [
									{
										key: '30',
										value: 'Health Benefit Plan Coverage (30)',
									},
									{
										key: '33',
										value: 'Chiropractic (33)',
									},
									{
										key: '35',
										value: 'Dental Care (35)',
									},
									{
										key: '86',
										value: 'Emergency Services (86)',
									},
									{
										key: '47',
										value: 'Hospital (47)',
									},
									{
										key: '48',
										value: 'Hospital - Inpatient (48)',
									},
									{
										key: '50',
										value: 'Hospital - Outpatient (50)',
									},
									{
										key: '1',
										value: 'Medical Care (1)',
									},
									{
										key: 'MH',
										value: 'Mental Health (MH)',
									},
									{
										key: '88',
										value: 'Pharmacy (88)',
									},
									{
										key: '98',
										value: 'Professional (Physician) Visit - Office (98)',
									},
									{
										key: 'UC',
										value: 'Urgent Care (UC)',
									},
									{
										key: 'AL',
										value: 'Vision (Optometry) (AL)',
									},
								],
								selectedSections: ['30', '33', '35', '86', '47', '48', '50', '1', 'MH', '88', '98', 'UC', 'AL'],
							},
						},
						{
							cEligibilitySummary: {
								eligibilitySummaryStatus: {
									classColor: 'eligibility-summary status-active',
									largeImage: 'Active_Coverage_White-Border.png',
									status: 'Active Coverage',
									description: 'Active Coverage',
								},
								eligibilityResponse: {
									responseDateTime: new Date('0001-01-01T00:00:00'),
									responseDateTimeString: '01-01-0001 12:00:00 AM',
									payer: {
										id: 1,
										code: '10000',
										name: 'Medicare (HETS)',
										payerTypeId: 1,
									},
									raw271:
										"ISA*00*          *00*          *ZZ*IVANS-MOCK-RT  *ZZ*EO-IVANS-RT    *210215*0012*^*00501*621248000*0*P*:~ GS*HB*IVANS-MOCK-RT*EO-IVANS-RT*20210215*0012*621248000*X*005010X279A1~ ST*271*100621249*005010X279A1~ BHT*0022*11*4139392*20210215*001252~ HL*1**20*1~NM1*PR*2*ABILITY Network - MOCK*****PI*13172~PER*IC*WA State DSHS Provider Relations*TE*8005623022~HL*2*1*21*1~NM1*1P*2*THREE RIVERS HOSP*****XX*1356305395~HL*3*2*22*0~TRN*2*970555*9876543210~TRN*1*621248*9ABILITYCH*REALTIME~TRN*1*3342773945*9ACSEDIGAT~NM1*IL*1*Smith*Mary*K***MI*100121A~REF*HJ*000000000~REF*18*181-HCA EAST~REF*IF*024-OKANOGAN CSO~N3*CY*024-OKANOGAN~DMG*D8*19650115*F~DTP*307*RD8*20140612-20140612~EB*1*IND*1^30^33^35^47^48^50^86^88^98^AL^MH^UC*MC*RAC=1204/BSP=CNP~REF*NQ*025941741~REF*6P*N11*6P - ACES Coverage Group Code~DTP*356*D8*20140401~DTP*357*D8*29991231~MSG*This is the Client's eligibility as of this date, based on information available at this time~EB*A*IND*30*MC*RAC=1204/BSP=CNP***0~EB*B*IND*30*MC*RAC=1204/BSP=CNP**0~EB*C*IND*30*MC*RAC=1204/BSP=CNP**0~EB*R*IND*30*C1~REF*IG*ZNE101181930~DTP*193*D8*20130101~DTP*194*D8*29991231~LS*2120~NM1*PR*2*LIFEWISE*****PI*PH09~NM1*IL*1*VAN WEERDHUIZEN*JUSTIN*T~PER*IC**TE*8007771502~LE*2120~EB*MC*IND**HM~DTP*193*D8*20140401~DTP*194*D8*29991231~LS*2120~NM1*Y2*2*Spokane RSN - Mental Health Services Only*****PI*105021301~PER*IC*SPOKANE RSN - MENTAL HEALTH SERVICES ONLY*TE*8002735864~LE*2120~ SE*44*100621249~ GE*1*621248000~ IEA*1*621248000~ ",
									eligibilityBenefits: [
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '1',
											serviceTypeCodeDefinition: 'Medical Care',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '33',
											serviceTypeCodeDefinition: 'Chiropractic',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '35',
											serviceTypeCodeDefinition: 'Dental Care',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '47',
											serviceTypeCodeDefinition: 'Hospital',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '48',
											serviceTypeCodeDefinition: 'Hospital - Inpatient',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '50',
											serviceTypeCodeDefinition: 'Hospital - Outpatient',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '86',
											serviceTypeCodeDefinition: 'Emergency Services',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '88',
											serviceTypeCodeDefinition: 'Pharmacy',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '98',
											serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'AL',
											serviceTypeCodeDefinition: 'Vision (Optometry)',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'MH',
											serviceTypeCodeDefinition: 'Mental Health',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'UC',
											serviceTypeCodeDefinition: 'Urgent Care',
											additionalIdentifications: [
												{
													identifier: '025941741',
													identifierCode: 'NQ',
													identifierCodeDefinition: 'Medicaid Recipient Identification Number',
													description: null,
												},
												{
													identifier: 'N11',
													identifierCode: '6P',
													identifierCodeDefinition: 'Group Number',
													description: '6P - ACES Coverage Group Code',
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: "This is the Client's eligibility as of this date, based on information available at this time",
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'A',
											benefitInfoCodeDefinition: 'Co-Insurance',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: '',
											percent: 0.0,
											percentString: '0',
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: '0',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [],
										},
										{
											authRequired: null,
											benefitInfoCode: 'C',
											benefitInfoCodeDefinition: 'Deductible',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'RAC=1204/BSP=CNP',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: '0',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [],
										},
										{
											authRequired: null,
											benefitInfoCode: 'R',
											benefitInfoCodeDefinition: 'Other or Additional Payer',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: null,
											insuranceTypeCode: 'C1',
											insuranceTypeCodeDefinition: 'Commercial',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [
												{
													identifier: 'ZNE101181930',
													identifierCode: 'IG',
													identifierCodeDefinition: 'Insurance Policy Number',
													description: null,
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'LIFEWISE',
													firstName: '',
													middleName: '',
													nameSuffix: '',
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: 'PH09',
													providerIdentifierCode: 'PI',
													providerIdentifierCodeDefinition: 'Payer Identification',
													relatedEntityContacts: [],
												},
											],
											textMessages: [],
										},
										{
											authRequired: null,
											benefitInfoCode: 'R',
											benefitInfoCodeDefinition: 'Other or Additional Payer',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: null,
											insuranceTypeCode: 'C1',
											insuranceTypeCodeDefinition: 'Commercial',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [
												{
													identifier: 'ZNE101181930',
													identifierCode: 'IG',
													identifierCodeDefinition: 'Insurance Policy Number',
													description: null,
												},
											],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'IL',
													typeCodeDefinition: 'Insured or Subscriber',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'VAN WEERDHUIZEN',
													firstName: 'JUSTIN',
													middleName: 'T',
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [
														{
															Name: '',
															Number1: '(800) 777-1502',
															Number1Code: 'TE',
															Number1CodeDefinition: 'Telephone',
															Number2: null,
															Number2Code: null,
															Number2CodeDefinition: null,
															Number3: null,
															Number3Code: null,
															Number3CodeDefinition: null,
														},
													],
												},
											],
											textMessages: [],
										},
										{
											authRequired: null,
											benefitInfoCode: 'MC',
											benefitInfoCodeDefinition: 'Managed Care Coordinator',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: null,
											insuranceTypeCode: 'HM',
											insuranceTypeCodeDefinition: 'Health Maintenance Organization (HMO)',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: null,
											serviceTypeCodeDefinition: null,
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'Y2',
													typeCodeDefinition: 'Managed Care Organization',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Spokane RSN - Mental Health Services Only',
													firstName: '',
													middleName: '',
													nameSuffix: '',
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: '105021301',
													providerIdentifierCode: 'PI',
													providerIdentifierCodeDefinition: 'Payer Identification',
													relatedEntityContacts: [
														{
															Name: 'SPOKANE RSN - MENTAL HEALTH SERVICES ONLY',
															Number1: '(800) 273-5864',
															Number1Code: 'TE',
															Number1CodeDefinition: 'Telephone',
															Number2: null,
															Number2Code: null,
															Number2CodeDefinition: null,
															Number3: null,
															Number3Code: null,
															Number3CodeDefinition: null,
														},
													],
												},
											],
											textMessages: [],
										},
									],
									requestErrors: [],
									createdDate: new Date('2021-02-25T14:02:05.8333702+05:30'),
									subscriber: {
										firstName: 'Mary',
										middleName: 'K',
										lastName: 'Smith',
										address1: 'CY',
										address2: '024-OKANOGAN',
										city: null,
										state: null,
										zip: null,
										dateOfBirth: new Date('1965-01-15T00:00:00'),
										dateOfBirthString: new Date('1965-01-15'),
										gender: 'F',
										identifier: '100121A',
										identifierCode: 'MI',
										identifierCodeDefinition: 'Member Identification Number',
										nameSuffix: '',
										dependent: {
											firstName: null,
											middleName: null,
											lastName: null,
											address1: null,
											address2: null,
											nameSuffix: null,
											city: null,
											state: null,
											zip: null,
											dateOfBirth: new Date('0001-01-01T00:00:00'),
											dateOfBirthString: new Date('0001-01-01'),
											gender: null,
											identifier: null,
											identifierCode: null,
											identifierCodeDefinition: null,
											additionalIdentifications: [],
											traceNumberIdentifications: [],
										},

										eligibilityBenefits: [
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '1',
												serviceTypeCodeDefinition: 'Medical Care',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '33',
												serviceTypeCodeDefinition: 'Chiropractic',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '35',
												serviceTypeCodeDefinition: 'Dental Care',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '47',
												serviceTypeCodeDefinition: 'Hospital',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '48',
												serviceTypeCodeDefinition: 'Hospital - Inpatient',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '50',
												serviceTypeCodeDefinition: 'Hospital - Outpatient',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '86',
												serviceTypeCodeDefinition: 'Emergency Services',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '88',
												serviceTypeCodeDefinition: 'Pharmacy',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '98',
												serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: 'AL',
												serviceTypeCodeDefinition: 'Vision (Optometry)',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: 'MH',
												serviceTypeCodeDefinition: 'Mental Health',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: '1',
												benefitInfoCodeDefinition: 'Active Coverage',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: 'UC',
												serviceTypeCodeDefinition: 'Urgent Care',
												additionalIdentifications: [
													{
														identifier: '025941741',
														identifierCode: 'NQ',
														identifierCodeDefinition: 'Medicaid Recipient Identification Number',
														description: null,
													},
													{
														identifier: 'N11',
														identifierCode: '6P',
														identifierCodeDefinition: 'Group Number',
														description: '6P - ACES Coverage Group Code',
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [
													{
														message: "This is the Client's eligibility as of this date, based on information available at this time",
													},
												],
											},
											{
												authRequired: null,
												benefitInfoCode: 'A',
												benefitInfoCodeDefinition: 'Co-Insurance',
												benefitTimePeriodCode: '',
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: '',
												percent: 0.0,
												percentString: '0',
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [],
											},
											{
												authRequired: null,
												benefitInfoCode: 'B',
												benefitInfoCodeDefinition: 'Co-Payment',
												benefitTimePeriodCode: '',
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: '0',
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [],
											},
											{
												authRequired: null,
												benefitInfoCode: 'C',
												benefitInfoCodeDefinition: 'Deductible',
												benefitTimePeriodCode: '',
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: 'RAC=1204/BSP=CNP',
												insuranceTypeCode: 'MC',
												insuranceTypeCodeDefinition: 'Medicaid',
												monetaryAmount: 0.0,
												monetaryAmountString: '0',
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [],
												textMessages: [],
											},
											{
												authRequired: null,
												benefitInfoCode: 'R',
												benefitInfoCodeDefinition: 'Other or Additional Payer',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: null,
												insuranceTypeCode: 'C1',
												insuranceTypeCodeDefinition: 'Commercial',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [
													{
														identifier: 'ZNE101181930',
														identifierCode: 'IG',
														identifierCodeDefinition: 'Insurance Policy Number',
														description: null,
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [
													{
														typeCode: 'PR',
														typeCodeDefinition: 'Payer',
														qualifierCode: null,
														qualifierCodeDefinition: null,
														lastOrOrgName: 'LIFEWISE',
														firstName: '',
														middleName: '',
														nameSuffix: '',
														identifier: null,
														identifierCode: null,
														identifierCodeDefinition: null,
														address1: null,
														address2: null,
														city: null,
														state: null,
														zip: null,

														providerCodeDefinition: null,
														providerIdentifier: 'PH09',
														providerIdentifierCode: 'PI',
														providerIdentifierCodeDefinition: 'Payer Identification',
														relatedEntityContacts: [],
													},
												],
												textMessages: [],
											},
											{
												authRequired: null,
												benefitInfoCode: 'R',
												benefitInfoCodeDefinition: 'Other or Additional Payer',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: null,
												insuranceTypeCode: 'C1',
												insuranceTypeCodeDefinition: 'Commercial',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: '30',
												serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
												additionalIdentifications: [
													{
														identifier: 'ZNE101181930',
														identifierCode: 'IG',
														identifierCodeDefinition: 'Insurance Policy Number',
														description: null,
													},
												],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [
													{
														typeCode: 'IL',
														typeCodeDefinition: 'Insured or Subscriber',
														qualifierCode: null,
														qualifierCodeDefinition: null,
														lastOrOrgName: 'VAN WEERDHUIZEN',
														firstName: 'JUSTIN',
														middleName: 'T',
														nameSuffix: null,
														identifier: null,
														identifierCode: null,
														identifierCodeDefinition: null,
														address1: null,
														address2: null,
														city: null,
														state: null,
														zip: null,

														providerCodeDefinition: null,
														providerIdentifier: null,
														providerIdentifierCode: null,
														providerIdentifierCodeDefinition: '',
														relatedEntityContacts: [
															{
																Name: '',
																Number1: '(800) 777-1502',
																Number1Code: 'TE',
																Number1CodeDefinition: 'Telephone',
																Number2: null,
																Number2Code: null,
																Number2CodeDefinition: null,
																Number3: null,
																Number3Code: null,
																Number3CodeDefinition: null,
															},
														],
													},
												],
												textMessages: [],
											},
											{
												authRequired: null,
												benefitInfoCode: 'MC',
												benefitInfoCodeDefinition: 'Managed Care Coordinator',
												benefitTimePeriodCode: null,
												benefitTimePeriodCodeDefinition: null,
												coverageLevelCode: 'IND',
												coverageLevelCodeDefinition: 'Individual',
												inNetwork: null,
												insuranceDescription: null,
												insuranceTypeCode: 'HM',
												insuranceTypeCodeDefinition: 'Health Maintenance Organization (HMO)',
												monetaryAmount: 0.0,
												monetaryAmountString: null,
												percent: 0.0,
												percentString: null,
												procedureCode: null,
												procedureCodeEnd: null,
												procedureModifier1: null,
												procedureModifier2: null,
												procedureModifier3: null,
												procedureModifier4: null,
												quantity: 0.0,
												quantityString: null,
												quantityQualifierCode: null,
												quantityQualifierCodeDefinition: '',
												serviceTypeCode: null,
												serviceTypeCodeDefinition: null,
												additionalIdentifications: [],
												benefitAdditionalInfos: [],

												deliveryPatterns: [],
												relatedEntities: [
													{
														typeCode: 'Y2',
														typeCodeDefinition: 'Managed Care Organization',
														qualifierCode: null,
														qualifierCodeDefinition: null,
														lastOrOrgName: 'Spokane RSN - Mental Health Services Only',
														firstName: '',
														middleName: '',
														nameSuffix: '',
														identifier: null,
														identifierCode: null,
														identifierCodeDefinition: null,
														address1: null,
														address2: null,
														city: null,
														state: null,
														zip: null,

														providerCodeDefinition: null,
														providerIdentifier: '105021301',
														providerIdentifierCode: 'PI',
														providerIdentifierCodeDefinition: 'Payer Identification',
														relatedEntityContacts: [
															{
																Name: 'SPOKANE RSN - MENTAL HEALTH SERVICES ONLY',
																Number1: '(800) 273-5864',
																Number1Code: 'TE',
																Number1CodeDefinition: 'Telephone',
																Number2: null,
																Number2Code: null,
																Number2CodeDefinition: null,
																Number3: null,
																Number3Code: null,
																Number3CodeDefinition: null,
															},
														],
													},
												],
												textMessages: [],
											},
										],
										requestErrors: [],
										additionalIdentifications: [
											{
												Identifier: '000000000',
												IdentifierCode: 'HJ',
												IdentifierCodeDefinition: 'Identity Card Number',
												Description: null,
											},
											{
												Identifier: '181-HCA EAST',
												IdentifierCode: '18',
												IdentifierCodeDefinition: 'Plan Number',
												Description: null,
											},
											{
												Identifier: '024-OKANOGAN CSO',
												IdentifierCode: 'IF',
												IdentifierCodeDefinition: 'Issue Number',
												Description: null,
											},
										],
										traceNumberIdentifications: [
											{
												TraceTypeCode: '2',
												ReferenceIdentification: '970555',
												OriginatingCompanyIdentifier: '9876543210',
												ReferenceSubIdentification: null,
											},
											{
												TraceTypeCode: '1',
												ReferenceIdentification: '621248',
												OriginatingCompanyIdentifier: '9ABILITYCH',
												ReferenceSubIdentification: 'REALTIME',
											},
											{
												TraceTypeCode: '1',
												ReferenceIdentification: '3342773945',
												OriginatingCompanyIdentifier: '9ACSEDIGAT',
												ReferenceSubIdentification: null,
											},
										],
										textMessages: [],
									},
								},
								planName: 'LPPO-UNITEDHEALTHCARE NURSING HOME PLAN (PPO SNP)',
								effectiveDate: '6/1/2013',
								planNetwork: [],
								identifiers: [
									{
										item1: 'Sub. Group Number:',
										item2: '660415',
									},
								],
							},
							id: 'sectionCEligibility',
							loadOrder: 2,
							displayOrder: 3,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},

						{
							eligibilityResponse: {
								raw271: '',
								responseDateTime: new Date('2021-02-26T15:43:45'),
								responseDateTimeString: '02-26-2021 03:43:45 PM',
								payer: {
									id: 1,
									code: '10000',
									name: 'Medicare (HETS)',
									payerTypeId: 1,
								},

								eligibilityBenefits: [
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '30',
										serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '86',
										serviceTypeCodeDefinition: 'Emergency Services',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: 'AL',
										serviceTypeCodeDefinition: 'Vision (Optometry)',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '47',
										serviceTypeCodeDefinition: 'Hospital',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '1',
										serviceTypeCodeDefinition: 'Medical Care',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: 'UC',
										serviceTypeCodeDefinition: 'Urgent Care',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: 'MH',
										serviceTypeCodeDefinition: 'Mental Health',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '88',
										serviceTypeCodeDefinition: 'Pharmacy',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '48',
										serviceTypeCodeDefinition: 'Hospital - Inpatient',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '35',
										serviceTypeCodeDefinition: 'Dental Care',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '98',
										serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: '1',
										benefitInfoCodeDefinition: 'Active Coverage',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
										insuranceTypeCode: 'MC',
										insuranceTypeCodeDefinition: 'Medicaid',
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '50',
										serviceTypeCodeDefinition: 'Hospital - Outpatient',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: 'PR',
												typeCodeDefinition: 'Payer',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'Medicaid',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [],
											},
										],
										textMessages: [
											{
												message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'B',
										benefitInfoCodeDefinition: 'Co-Payment',
										benefitTimePeriodCode: '',
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: '',
										insuranceTypeCode: '',
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 0.0,
										monetaryAmountString: '0',
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '88',
										serviceTypeCodeDefinition: 'Pharmacy',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [],
										textMessages: [
											{
												message: '$1.00 for Generic or $3.00 for brand name',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'B',
										benefitInfoCodeDefinition: 'Co-Payment',
										benefitTimePeriodCode: '',
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: '',
										insuranceTypeCode: '',
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 0.0,
										monetaryAmountString: '0',
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '48',
										serviceTypeCodeDefinition: 'Hospital - Inpatient',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [],
										textMessages: [
											{
												message: '$10.00 per covered day or 50% of the average allowable daily rate whichever is less. The average allowable daily rate can be calculated using the Total allowed charge for the entire stay and divide by the',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'B',
										benefitInfoCodeDefinition: 'Co-Payment',
										benefitTimePeriodCode: '',
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: '',
										insuranceTypeCode: '',
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 0.0,
										monetaryAmountString: '0',
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '35',
										serviceTypeCodeDefinition: 'Dental Care',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [],
										textMessages: [
											{
												message: 'Children Only. Adults with a concurrent Medical Condition - Please see Provider Manual',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'B',
										benefitInfoCodeDefinition: 'Co-Payment',
										benefitTimePeriodCode: '',
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: '',
										insuranceTypeCode: '',
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 2.0,
										monetaryAmountString: '2',
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '98',
										serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [],
										textMessages: [
											{
												message: 'Per visit',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'B',
										benefitInfoCodeDefinition: 'Co-Payment',
										benefitTimePeriodCode: '',
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: 'IND',
										coverageLevelCodeDefinition: 'Individual',
										inNetwork: null,
										insuranceDescription: '',
										insuranceTypeCode: '',
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 3.0,
										monetaryAmountString: '3',
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: '50',
										serviceTypeCodeDefinition: 'Hospital - Outpatient',
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [],
										textMessages: [
											{
												message: 'Per visit',
											},
										],
									},
									{
										authRequired: null,
										benefitInfoCode: 'MC',
										benefitInfoCodeDefinition: 'Managed Care Coordinator',
										benefitTimePeriodCode: null,
										benefitTimePeriodCodeDefinition: null,
										coverageLevelCode: '',
										coverageLevelCodeDefinition: null,
										inNetwork: null,
										insuranceDescription: null,
										insuranceTypeCode: null,
										insuranceTypeCodeDefinition: null,
										monetaryAmount: 0.0,
										monetaryAmountString: null,
										percent: 0.0,
										percentString: null,
										procedureCode: null,
										procedureCodeEnd: null,
										procedureModifier1: null,
										procedureModifier2: null,
										procedureModifier3: null,
										procedureModifier4: null,
										quantity: 0.0,
										quantityString: null,
										quantityQualifierCode: null,
										quantityQualifierCodeDefinition: '',
										serviceTypeCode: null,
										serviceTypeCodeDefinition: null,
										additionalIdentifications: [],
										benefitAdditionalInfos: [],

										deliveryPatterns: [],
										relatedEntities: [
											{
												typeCode: '1P',
												typeCodeDefinition: 'Provider',
												qualifierCode: null,
												qualifierCodeDefinition: null,
												lastOrOrgName: 'COLORADO HEALTH NETWORKS',
												firstName: null,
												middleName: null,
												nameSuffix: null,
												identifier: null,
												identifierCode: null,
												identifierCodeDefinition: null,
												address1: null,
												address2: null,
												city: null,
												state: null,
												zip: null,

												providerCodeDefinition: null,
												providerIdentifier: null,
												providerIdentifierCode: null,
												providerIdentifierCodeDefinition: '',
												relatedEntityContacts: [
													{
														Name: '',
														Number1: '(800) 804-5008',
														Number1Code: 'TE',
														Number1CodeDefinition: 'Telephone',
														Number2: null,
														Number2Code: null,
														Number2CodeDefinition: null,
														Number3: null,
														Number3Code: null,
														Number3CodeDefinition: null,
													},
												],
											},
										],
										textMessages: [
											{
												message: 'MHPROV Services',
											},
										],
									},
								],
								requestErrors: [],
								createdDate: new Date('0001-01-01T00:00:00'),
								subscriber: {
									firstName: 'Jane',
									middleName: 'P',
									lastName: 'Shaw',
									address1: '101 Main St',
									address2: null,
									city: 'Any City',
									state: 'CO',
									zip: '81321-9187',
									dateOfBirth: new Date('1947-11-24T00:00:00'),
									dateOfBirthString: new Date('1947-11-24'),
									gender: 'F',
									identifier: '100096A',
									identifierCode: 'MI',
									identifierCodeDefinition: 'Member Identification Number',
									nameSuffix: '',
									dependent: {
										firstName: null,
										middleName: null,
										lastName: null,
										address1: null,
										address2: null,
										nameSuffix: null,
										city: null,
										state: null,
										zip: null,
										dateOfBirth: new Date('0001-01-01T00:00:00'),
										dateOfBirthString: new Date('0001-01-01'),
										gender: null,
										identifier: null,
										identifierCode: null,
										identifierCodeDefinition: null,
										additionalIdentifications: [],
										traceNumberIdentifications: [],
									},

									eligibilityBenefits: [
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '30',
											serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '86',
											serviceTypeCodeDefinition: 'Emergency Services',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'AL',
											serviceTypeCodeDefinition: 'Vision (Optometry)',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '47',
											serviceTypeCodeDefinition: 'Hospital',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '1',
											serviceTypeCodeDefinition: 'Medical Care',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'UC',
											serviceTypeCodeDefinition: 'Urgent Care',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],
											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: 'MH',
											serviceTypeCodeDefinition: 'Mental Health',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '88',
											serviceTypeCodeDefinition: 'Pharmacy',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '48',
											serviceTypeCodeDefinition: 'Hospital - Inpatient',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '35',
											serviceTypeCodeDefinition: 'Dental Care',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '98',
											serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: '1',
											benefitInfoCodeDefinition: 'Active Coverage',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: 'CO MEDICAL ASSISTANCE PROGRAMS',
											insuranceTypeCode: 'MC',
											insuranceTypeCodeDefinition: 'Medicaid',
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '50',
											serviceTypeCodeDefinition: 'Hospital - Outpatient',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: 'PR',
													typeCodeDefinition: 'Payer',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'Medicaid',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [],
												},
											],
											textMessages: [
												{
													message: '141640012569.This eligibility guarantee number does not apply to or cover future dates.',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: '',
											insuranceTypeCode: '',
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 0.0,
											monetaryAmountString: '0',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '88',
											serviceTypeCodeDefinition: 'Pharmacy',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: '$1.00 for Generic or $3.00 for brand name',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: '',
											insuranceTypeCode: '',
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 0.0,
											monetaryAmountString: '0',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '48',
											serviceTypeCodeDefinition: 'Hospital - Inpatient',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: '$10.00 per covered day or 50% of the average allowable daily rate whichever is less. The average allowable daily rate can be calculated using the Total allowed charge for the entire stay and divide by the',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: '',
											insuranceTypeCode: '',
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 0.0,
											monetaryAmountString: '0',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '35',
											serviceTypeCodeDefinition: 'Dental Care',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: 'Children Only. Adults with a concurrent Medical Condition - Please see Provider Manual',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: '',
											insuranceTypeCode: '',
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 2.0,
											monetaryAmountString: '2',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '98',
											serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: 'Per visit',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'B',
											benefitInfoCodeDefinition: 'Co-Payment',
											benefitTimePeriodCode: '',
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: 'IND',
											coverageLevelCodeDefinition: 'Individual',
											inNetwork: null,
											insuranceDescription: '',
											insuranceTypeCode: '',
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 3.0,
											monetaryAmountString: '3',
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: '50',
											serviceTypeCodeDefinition: 'Hospital - Outpatient',
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [],
											textMessages: [
												{
													message: 'Per visit',
												},
											],
										},
										{
											authRequired: null,
											benefitInfoCode: 'MC',
											benefitInfoCodeDefinition: 'Managed Care Coordinator',
											benefitTimePeriodCode: null,
											benefitTimePeriodCodeDefinition: null,
											coverageLevelCode: '',
											coverageLevelCodeDefinition: null,
											inNetwork: null,
											insuranceDescription: null,
											insuranceTypeCode: null,
											insuranceTypeCodeDefinition: null,
											monetaryAmount: 0.0,
											monetaryAmountString: null,
											percent: 0.0,
											percentString: null,
											procedureCode: null,
											procedureCodeEnd: null,
											procedureModifier1: null,
											procedureModifier2: null,
											procedureModifier3: null,
											procedureModifier4: null,
											quantity: 0.0,
											quantityString: null,
											quantityQualifierCode: null,
											quantityQualifierCodeDefinition: '',
											serviceTypeCode: null,
											serviceTypeCodeDefinition: null,
											additionalIdentifications: [],
											benefitAdditionalInfos: [],

											deliveryPatterns: [],
											relatedEntities: [
												{
													typeCode: '1P',
													typeCodeDefinition: 'Provider',
													qualifierCode: null,
													qualifierCodeDefinition: null,
													lastOrOrgName: 'COLORADO HEALTH NETWORKS',
													firstName: null,
													middleName: null,
													nameSuffix: null,
													identifier: null,
													identifierCode: null,
													identifierCodeDefinition: null,
													address1: null,
													address2: null,
													city: null,
													state: null,
													zip: null,

													providerCodeDefinition: null,
													providerIdentifier: null,
													providerIdentifierCode: null,
													providerIdentifierCodeDefinition: '',
													relatedEntityContacts: [
														{
															Name: '',
															Number1: '(800) 804-5008',
															Number1Code: 'TE',
															Number1CodeDefinition: 'Telephone',
															Number2: null,
															Number2Code: null,
															Number2CodeDefinition: null,
															Number3: null,
															Number3Code: null,
															Number3CodeDefinition: null,
														},
													],
												},
											],
											textMessages: [
												{
													message: 'MHPROV Services',
												},
											],
										},
									],
									requestErrors: [],
									additionalIdentifications: [],
									traceNumberIdentifications: [
										{
											TraceTypeCode: '2',
											ReferenceIdentification: '970555',
											OriginatingCompanyIdentifier: '9876543210',
											ReferenceSubIdentification: null,
										},
										{
											TraceTypeCode: '1',
											ReferenceIdentification: '644325',
											OriginatingCompanyIdentifier: '9ABILITYCH',
											ReferenceSubIdentification: 'REALTIME',
										},
										{
											TraceTypeCode: '1',
											ReferenceIdentification: '000000006454550',
											OriginatingCompanyIdentifier: '977016',
											ReferenceSubIdentification: null,
										},
									],
									textMessages: [],
								},
							},
							id: 'sectionBenefitInformation',
							loadOrder: 5,
							displayOrder: 6,
							isFiltered: false,
							summary: {
								title: 'Benefit Information',
								sections: [
									{
										key: '30',
										value: 'Health Benefit Plan Coverage (30)',
									},
									{
										key: '88',
										value: 'Pharmacy (88)',
									},
									{
										key: '32',
										value: 'Plan Waiting Period (32)',
									},
								],
								selectedSections: ['30', '88', '32'],
								insurances: [
									{
										planName: 'LPPO-UNITEDHEALTHCARE NURSING HOME PLAN (PPO SNP)',
										benefits: [],
										cInsuranceBenefits: [
											{
												code: 'X',
												description: 'Health Care Facility',
												lines: [
													{
														sections: [
															{
																isBold: false,
																value: "<span class='sectionHeader'>Name</span>: PRIMESOURCE HEALTHCARE",
															},
														],
													},
													{
														sections: [
															{
																isBold: false,
																value: "<span class='sectionHeader'>Centers for Medicare and Medicaid Services National Provider Identifier</span>: 1497704126",
															},
														],
													},
												],
											},
										],
									},
								],
								index: 0,
								preferenceKey: 'eligSum0',
							},
						},

						{
							id: 'sectionCServiceType',
							loadOrder: 7,
							displayOrder: 8,
							isFiltered: true,
							summary: {
								serviceTypes: [
									{
										serviceCode: '1',
										serviceCodeDescription: 'Medical Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '1',
														serviceTypeCodeDefinition: 'Medical Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '30',
										serviceCodeDescription: 'Health Benefit Plan Coverage',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
													{
														authRequired: null,
														benefitInfoCode: 'A',
														benefitInfoCodeDefinition: 'Co-Insurance',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '',
														percent: 0.0,
														percentString: '0',
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
													{
														authRequired: null,
														benefitInfoCode: 'B',
														benefitInfoCodeDefinition: 'Co-Payment',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '0',
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
													{
														authRequired: null,
														benefitInfoCode: 'C',
														benefitInfoCodeDefinition: 'Deductible',
														benefitTimePeriodCode: '',
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: '0',
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '30',
														serviceTypeCodeDefinition: 'Health Benefit Plan Coverage',
														additionalIdentifications: [],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [],
													},
												],
											},
										],
									},
									{
										serviceCode: '33',
										serviceCodeDescription: 'Chiropractic',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '33',
														serviceTypeCodeDefinition: 'Chiropractic',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '35',
										serviceCodeDescription: 'Dental Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '35',
														serviceTypeCodeDefinition: 'Dental Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '47',
										serviceCodeDescription: 'Hospital',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '47',
														serviceTypeCodeDefinition: 'Hospital',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '48',
										serviceCodeDescription: 'Hospital - Inpatient',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '48',
														serviceTypeCodeDefinition: 'Hospital - Inpatient',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '50',
										serviceCodeDescription: 'Hospital - Outpatient',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '50',
														serviceTypeCodeDefinition: 'Hospital - Outpatient',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '86',
										serviceCodeDescription: 'Emergency Services',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '86',
														serviceTypeCodeDefinition: 'Emergency Services',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '88',
										serviceCodeDescription: 'Pharmacy',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '88',
														serviceTypeCodeDefinition: 'Pharmacy',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: '98',
										serviceCodeDescription: 'Professional (Physician) Visit - Office',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: '98',
														serviceTypeCodeDefinition: 'Professional (Physician) Visit - Office',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'AL',
										serviceCodeDescription: 'Vision (Optometry)',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'AL',
														serviceTypeCodeDefinition: 'Vision (Optometry)',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'MH',
										serviceCodeDescription: 'Mental Health',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'MH',
														serviceTypeCodeDefinition: 'Mental Health',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
									{
										serviceCode: 'UC',
										serviceCodeDescription: 'Urgent Care',
										isActive: true,
										status: 'Active Coverage',
										insurances: [
											{
												planName: 'RAC=1204/BSP=CNP',

												insuranceTypeDescription: 'Medicaid',
												coverageLevel: 'IND',
												coverageLevelDescription: 'Individual',
												benefits: [
													{
														authRequired: null,
														benefitInfoCode: '1',
														benefitInfoCodeDefinition: 'Active Coverage',
														benefitTimePeriodCode: null,
														benefitTimePeriodCodeDefinition: null,
														coverageLevelCode: 'IND',
														coverageLevelCodeDefinition: 'Individual',
														inNetwork: null,
														insuranceDescription: 'RAC=1204/BSP=CNP',
														insuranceTypeCode: 'MC',
														insuranceTypeCodeDefinition: 'Medicaid',
														monetaryAmount: 0.0,
														monetaryAmountString: null,
														percent: 0.0,
														percentString: null,
														procedureCode: null,
														procedureCodeEnd: null,
														procedureModifier1: null,
														procedureModifier2: null,
														procedureModifier3: null,
														procedureModifier4: null,
														quantity: 0.0,
														quantityString: null,
														quantityQualifierCode: null,
														quantityQualifierCodeDefinition: '',
														serviceTypeCode: 'UC',
														serviceTypeCodeDefinition: 'Urgent Care',
														additionalIdentifications: [
															{
																identifier: '025941741',
																identifierCode: 'NQ',
																identifierCodeDefinition: 'Medicaid Recipient Identification Number',
																description: null,
															},
															{
																identifier: 'N11',
																identifierCode: '6P',
																identifierCodeDefinition: 'Group Number',
																description: '6P - ACES Coverage Group Code',
															},
														],
														benefitAdditionalInfos: [],

														deliveryPatterns: [],
														relatedEntities: [],
														textMessages: [
															{
																message: "This is the Client's eligibility as of this date, based on information available at this time",
															},
														],
													},
												],
											},
										],
									},
								],
								index: 5,
								preferenceKey: 'eligSum5',
								title: 'Service Types',
								sections: [
									{
										key: '30',
										value: 'Health Benefit Plan Coverage (30)',
									},
									{
										key: '33',
										value: 'Chiropractic (33)',
									},
									{
										key: '35',
										value: 'Dental Care (35)',
									},
									{
										key: '86',
										value: 'Emergency Services (86)',
									},
									{
										key: '47',
										value: 'Hospital (47)',
									},
									{
										key: '48',
										value: 'Hospital - Inpatient (48)',
									},
									{
										key: '50',
										value: 'Hospital - Outpatient (50)',
									},
									{
										key: '1',
										value: 'Medical Care (1)',
									},
									{
										key: 'MH',
										value: 'Mental Health (MH)',
									},
									{
										key: '88',
										value: 'Pharmacy (88)',
									},
									{
										key: '98',
										value: 'Professional (Physician) Visit - Office (98)',
									},
									{
										key: 'UC',
										value: 'Urgent Care (UC)',
									},
									{
										key: 'AL',
										value: 'Vision (Optometry) (AL)',
									},
								],
								selectedSections: ['30', '33', '35', '86', '47', '48', '50', '1', 'MH', '88', '98', 'UC', 'AL'],
							},
						},
						{
							id: '1',
							loadOrder: 0,
							displayOrder: 0,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
						{
							displayOrder: 10,
							id: 'sectionPreventative',
							isFiltered: true,
							loadOrder: 9,
							summary: {
								index: 5,
								preferenceKey: 'eligSum5',
								sections: [
									{ key: '77057', value: 'Screening Mammography (MAMM) - 77057' },
									{ key: '80061', value: 'Cardiovascular Disease Screening (CARD) - 80061' },
									{ key: '82270', value: 'Fecal Occult Blood Test (FOBT) - 82270' },
								],
								selectedSections: ['77057', '80061', '82270'],
								procedureCodes: [
									{
										code: '90670',
										definition: 'Screening Mammography (MAMM)',
										eligibleProfessional: new Date(1167589800000),
										eligibleTechnical: new Date(1167589800000),
										homeCertificationDates: [],
										homeRecertificationDates: [],
										deductibleTotal: 30,
										deductibleRemaining: 20,
										coInsurance: 15,
										providerNPI: 'Dev123',
										pPVDos: [
											{ key: '1/1/2013', value: '123' },
											{ key: '1/1/2014', value: '456' },
											{ key: '1/1/2015', value: '173' },
											{ key: '1/1/2016', value: '189' },
										],
									},
									{ code: '90732', definition: 'Cardiovascular Disease Screening(CARD)', eligibleProfessional: new Date(1136053800000), eligibleTechnical: new Date(1136053800000), homeCertificationDates: [], homeRecertificationDates: [], deductibleTotal: 30, deductibleRemaining: 20, coInsurance: 15, providerNPI: 'Dev123-1', pPVDos: [{ key: '1/1/2013', value: '123' }] },
									{ code: '90999', definition: 'Cardiovascular Disease(CARD)', eligibleProfessional: new Date(1136053800000), eligibleTechnical: new Date(1136053800000), homeCertificationDates: [], homeRecertificationDates: [], deductibleTotal: 30, deductibleRemaining: 20, coInsurance: 20, providerNPI: 'Dev123-1', pPVDos: [{ key: '1/1/2013', value: '123' }] },

									{ code: '90670', definition: 'Fecal Occult Blood Test (FOBT)', eligibleProfessional: new Date(1167589800000), eligibleTechnical: new Date(1167589800000), homeCertificationDates: [], homeRecertificationDates: [], deductibleTotal: 0, deductibleRemaining: 0, coInsurance: 0, providerNPI: null, pPVDos: [] },
								],

								title: 'Preventative',
								isHCPCS: false,
							},
						},
						{
							id: 'sectionStatusAlerts',
							loadOrder: 4,
							displayOrder: 5,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum - 1',
								title: 'Status Alert',
								sections: [],
								selectedSections: ['0', '1'],
							},
							statusAlerts: {
								insurances: [
									{
										type: 3,
										typeString: 'Medicare Part D',
										code: 'HN',
										definition: 'Other',
										insuranceDescription: 'null',
										additionalPayers: [
											{
												additionalIdentifiers: [
													{
														identifier: 'S5820 012',
														identifierCode: '18',
														identifierCodeDefinition: 'Plan Number',
														description: 'null',
													},
												],
												startDate: new Date('2015-10-02T00:00:00'),
												endDate: new Date('2015-12-02T00:00:00'),
												message: 'MCO BILL OPTION CODE',
												insuranceTypeCodeDefinition: 'Other',
												name: 'UNITEDHEALTHCARE INSURANCE COMPANY-1-1',
												address1: '450 Columbus Blvd.',
												address2: 'null',
												city: 'Hartford',
												state: 'CT',
												zip: '061030472',
												telephone: '9177541472',
											},
											{
												additionalIdentifiers: [
													{
														identifier: 'S5820 012',
														identifierCode: '18',
														identifierCodeDefinition: 'Plan Number',
														description: 'null',
													},
												],
												startDate: new Date('2015-10-02T00:00:00'),
												endDate: new Date('2015-12-02T00:00:00'),
												message: 'MA BILL OPTION CODE',
												insuranceTypeCodeDefinition: 'Other',
												name: 'UNITEDHEALTHCARE INSURANCE COMPANY-1-2',
												address1: '450 Columbus Blvd.',
												address2: 'null',
												city: 'Hartford',
												state: 'CT',
												zip: '06103-0450',
												telephone: '9133714971',
											},
											{
												additionalIdentifiers: [
													{
														identifier: 'S5820 012',
														identifierCode: '18',
														identifierCodeDefinition: 'Plan Number',
														description: 'null',
													},
												],
												startDate: new Date('2015-10-02T00:00:00'),
												endDate: new Date('2015-12-02T00:00:00'),
												message: 'MCO BILL OPTION CODE',
												insuranceTypeCodeDefinition: 'Other',
												name: 'UNITEDHEALTHCARE INSURANCE COMPANY',
												address1: '450 Columbus Blvd.',
												address2: 'null',
												city: 'Hartford',
												state: 'CT',
												zip: '06103-0450',
												telephone: '(877) 842-3210',
											},
										],
										effectiveDateRanges: [],
										coInsurances: [],
										coPayments: {
											episodeDefinition: 'Spell',
											frequencyDefinition: 'null',
											periodDefinition: 'null',
											schedules: [],
											episodes: [],
										},
										deductibles: {
											episodeDefinition: 'Spell',
											episodes: [],
											schedules: [],
										},
										reserve: {
											quantityQualifier: 'null',
											lifetime: 0,
											remaining: 0,
											coPays: [],
										},
										descriptions: [],
										limitations: [],
										endOfPeriod2: null,
									},
									{
										type: 3,
										typeString: 'Medicare Part D',
										code: '12',
										definition: 'Other',
										insuranceDescription: 'null',
										additionalPayers: [
											{
												additionalIdentifiers: [
													{
														identifier: 'S5820 012',
														identifierCode: '18',
														identifierCodeDefinition: 'Plan Number',
														description: 'null',
													},
												],
												startDate: new Date('2015-10-02T00:00:00'),
												endDate: new Date('2015-12-02T00:00:00'),
												message: 'MA BILL OPTION CODE',
												insuranceTypeCodeDefinition: 'Other',
												name: 'UNITEDHEALTHCARE INSURANCE COMPANY-2-2',
												address1: '450 Columbus Blvd.',
												address2: 'null',
												city: 'Hartford',
												state: 'CT',
												zip: '06103',
												telephone: '(877) 842-3210',
											},
											{
												additionalIdentifiers: [
													{
														identifier: 'S5820 012',
														identifierCode: '18',
														identifierCodeDefinition: 'Plan Number',
														description: 'null',
													},
												],
												startDate: new Date('2015-10-02T00:00:00'),
												endDate: new Date('2015-12-02T00:00:00'),
												message: 'MCO BILL OPTION CODE',
												insuranceTypeCodeDefinition: 'Other',
												name: 'UNITEDHEALTHCARE INSURANCE COMPANY-2',
												address1: '450 Columbus Blvd.',
												address2: 'null',
												city: 'Hartford',
												state: 'CT',
												zip: '06103-0450',
												telephone: '(877) 842-3210',
											},
											{
												additionalIdentifiers: [
													{
														identifier: 'S5820 012',
														identifierCode: '18',
														identifierCodeDefinition: 'Plan Number',
														description: 'null',
													},
												],
												startDate: new Date('2015-12-02T00:00:00'),
												endDate: new Date('2015-12-02T00:00:00'),
												message: 'MA BILL OPTION CODE',
												insuranceTypeCodeDefinition: 'Other',
												name: 'UNITEDHEALTHCARE INSURANCE COMPANY-2-1',
												address1: '450 Columbus Blv1d.',
												address2: '',
												city: 'Hartford',
												state: 'AK',
												zip: '06103-0450',
												telephone: '(877) 842-3210',
											},
										],
										effectiveDateRanges: [],
										coInsurances: [],
										coPayments: {
											episodeDefinition: 'Spell',
											frequencyDefinition: 'null',
											periodDefinition: 'null',
											schedules: [],
											episodes: [],
										},
										deductibles: {
											episodeDefinition: 'Spell',
											episodes: [],
											schedules: [],
										},
										reserve: {
											quantityQualifier: 'null',
											lifetime: 0,
											remaining: 0,
											coPays: [],
										},
										descriptions: [],
										limitations: [],
										endOfPeriod2: null,
									},
								],
								matchedOtherPayers: null,
							},
						},
						{
							mcoStatusAlertSectionViewModels: [
								{
									id: 1,
									cLineList: [
										{
											sections: [
												{
													isBold: false,
													value: 'FullName',
												},
												{
													isBold: false,
													value: 'NETWORK HEALTH LLC',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Address',
												},
												{
													isBold: false,
													value: '101 STATION LNDG, MEDFORD, MA 02155',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Telephone',
												},
												{
													isBold: false,
													value: '(888) 257-1985',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'PlanDescription',
												},
												{
													isBold: false,
													value: 'INTEGRATED CARE ORGANIZATIONS',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'ServiceType',
												},
												{
													isBold: false,
													value: 'Health Benefit Plan Coverage',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'StartDate',
												},
												{
													isBold: false,
													value: '10/2/2015',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'EndDate',
												},
												{
													isBold: false,
													value: '10/2/2015',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Message',
												},
												{
													isBold: false,
													value: '669 One Care. Network Health member. For medical, behavioral health, and long-term services and support services, call 1-888-257-1985.',
												},
											],
										},
									],
								},
								{
									id: 2,
									cLineList: [
										{
											sections: [
												{
													isBold: false,
													value: 'FullName',
												},
												{
													isBold: false,
													value: 'TUFTS-NETWORK HEALTH',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Address',
												},
												{
													isBold: false,
													value: '101 STATION LNDG 4 FL, MEDFORD, MA 02155',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Telephone',
												},
												{
													isBold: false,
													value: '(888) 257-1985',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'PlanDescription',
												},
												{
													isBold: false,
													value: 'MCO STANDARD',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'ServiceType',
												},
												{
													isBold: false,
													value: 'Health Benefit Plan Coverage',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'StartDate',
												},
												{
													isBold: false,
													value: '10/2/2015',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'EndDate',
												},
												{
													isBold: false,
													value: '10/2/2015',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'StartDate',
												},
												{
													isBold: false,
													value: '1/2/2020',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'EndDate',
												},
												{
													isBold: false,
													value: '10/2/2020',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Message',
												},
												{
													isBold: false,
													value: '616 NETWORK HEALTH MEMBER. FOR DENTAL SERVICES CALL 1-888-257-1985. FOR VISION SERVICES CALL 1-888-257-1985',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Message',
												},
												{
													isBold: false,
													value: '056 NETWORK HEALTH MEMBER. For Medical Services call 1-888-257-1985. For Behavioral Health Services call 1-888-257-1985.',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Message',
												},
												{
													isBold: false,
													value: '669 One Care. Network Health member. For medical, behavioral health, and long-term services and support services, call 1-888-256-1986.',
												},
											],
										},
									],
								},
								{
									id: 3,
									cLineList: [
										{
											sections: [
												{
													isBold: false,
													value: 'FullName',
												},
												{
													isBold: false,
													value: 'NETWORK HEALTH LLC updated',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Address',
												},
												{
													isBold: false,
													value: '101 STATION LNDG, MEDFORD, MA 02155',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Telephone',
												},
												{
													isBold: false,
													value: '(888) 257-1985',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'PlanDescription',
												},
												{
													isBold: false,
													value: 'INTEGRATED CARE ORGANIZATIONS Updated12',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'ServiceType',
												},
												{
													isBold: false,
													value: 'Health Benefit Plan Coverage',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'StartDate',
												},
												{
													isBold: false,
													value: '10/2/2015',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'EndDate',
												},
												{
													isBold: false,
													value: '10/2/2015',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Message',
												},
												{
													isBold: false,
													value: '669 One Care. Network Health member. For medical, behavioral health, and long-term services and support services, call 1-888-257-1985.',
												},
											],
										},
									],
								},
							],
							id: 'sectionMCOStatusAlert',
							loadOrder: 3,
							displayOrder: 4,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
						{
							pcpSectionViewModels: [
								{
									id: 1,
									cLineList: [
										{
											sections: [
												{
													isBold: false,
													value: 'PolicyNumber',
												},
												{
													isBold: false,
													value: 'S14569',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'FullName',
												},
												{
													isBold: false,
													value: 'Aetna',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Address',
												},
												{
													isBold: false,
													value: 'Bowman ST West Chicago, CT, 678799',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Telephone',
												},
												{
													isBold: false,
													value: '(800) 998-9789',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'PlanDescription',
												},
												{
													isBold: false,
													value: 'Master Policy',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'ServiceType',
												},
												{
													isBold: false,
													value: 'Health Benefit Plan Coverage',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'StartDate',
												},
												{
													isBold: false,
													value: '8/8/2014',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Message',
												},
												{
													isBold: false,
													value: 'Policy Term',
												},
											],
										},
									],
								},
							],
							id: 'sectionPCP',
							loadOrder: 4,
							displayOrder: 5,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
						{
							otherPayersSectionViewModels: [
								{
									id: 1,
									cLineList: [
										{
											sections: [
												{
													isBold: false,
													value: 'Insurance Type',
												},
												{
													isBold: false,
													value: 'Life Insurance',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Plan Description',
												},
												{
													isBold: false,
													value: 'Master Policy',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Service Type',
												},
												{
													isBold: false,
													value: 'Health Benefit Plan Coverage',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Insurance Policy Number',
												},
												{
													isBold: false,
													value: 'S14569',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Name',
												},
												{
													isBold: false,
													value: 'Aetna',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Address',
												},
												{
													isBold: false,
													value: 'Bowman ST',
												},
												{
													isBold: false,
													value: ' West Chicago',
												},
												{
													isBold: false,
													value: ', CT',
												},
												{
													isBold: false,
													value: ', 678799',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'StartDate',
												},
												{
													isBold: false,
													value: '8/8/2014',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'EndDate',
												},
												{
													isBold: false,
													value: '9/9/2014',
												},
											],
										},
										{
											sections: [
												{
													isBold: false,
													value: 'Message',
												},
												{
													isBold: false,
													value: 'Policy Term',
												},
											],
										},
									],
								},
							],
							id: 'sectionOtherPayer',
							loadOrder: 6,
							displayOrder: 7,
							isFiltered: false,
							summary: {
								index: -1,
								preferenceKey: 'eligSum-1',
								title: '',
								sections: [],
								selectedSections: [],
							},
						},
					],
				},
			],
		})
	}

	getBaseResponseDetails(transactionResponseId: number): Promise<IBaseResponseDetail[]> {
		return new Promise<IBaseResponseDetail[]>(resolve => {
			resolve(this.baseResponseDetail)
		})
	}

	getResponse(id: number): Promise<IBaseResponse> {
		return new Promise<IBaseResponse>(resolve => {
			if (id === 1) resolve(this.allResponses[0].response[0])
			if (id === 2) resolve(this.allResponses[0].response[1])
			if (id === 3) resolve(this.allResponses[0].response[2])
		})
	}
}
